export default {
  common: {
    cancel: '취소',
    clear: '지우기',
    update: '업데이트',
    downloading: '다운로드 ',
    models: '모델',
    add: '추가',
    create: '생성',
    edit: '편집',
    rename: '이름 변경',
    delete: '삭제',
    move: '이동',
    remove: '제거',
    duplicate: '복제',
    reset: '초기화',
    share: '공유',
    save: '저장',
    done: '완료',
    download: '다운로드',
    first_name: '이름',
    last_name: '성',
    name: '이름',
    email: '이메일',
    phone: '전화번호',
    password: '비밀번호',
    verify: '인증',
    selectedOrg: '선택한 조직',
    page: '페이지',
    loading: '로딩 중...',
    my_projects: '내 프로젝트',
    team_projects: '팀 프로젝트',
    shared_projects: '공유 프로젝트',
    current_task: '현재 작업',
    selected: '선택됨',
    unselect: '선택 해제',
    login: '로그인',
    search: '검색',
    analyze: '분석',
    checked: '체크됨',
    unchecked: '체크 안됨',
    title: '제목',
    untitled: '제목 없음',
    link: '링크',
    apply: '적용',
    role: '역할',
    credits: '크레딧',
    credits_no: '{{count}} 크레딧',
    yes: '예',
    no: '아니요',
    close: '닫기',
  },
  role: {
    owner: '소유자',
    admin: '관리자',
    manager: '매니저',
    member: '멤버',
    user: '멤버',
  },
  country_code: {
    AF: '아프가니스탄',
    AL: '알바니아',
    DZ: '알제리',
    AS: '아메리칸사모아',
    AD: '안도라',
    AO: '앙골라',
    AI: '앵귈라',
    AQ: '남극',
    AG: '앤티가바부다',
    AR: '아르헨티나',
    AM: '아르메니아',
    AW: '아루바',
    AU: '호주',
    AT: '오스트리아',
    AZ: '아제르바이잔',
    BS: '바하마',
    BH: '바레인',
    BD: '방글라데시',
    BB: '바베이도스',
    BY: '벨라루스',
    BE: '벨기에',
    BZ: '벨리즈',
    BJ: '베냉',
    BM: '버뮤다',
    BT: '부탄',
    BO: '볼리비아',
    BA: '보스니아 헤르체고비나',
    BW: '보츠와나',
    BV: '부베 섬',
    BR: '브라질',
    IO: '영국령 인도양 지역',
    BN: '브루나이',
    BG: '불가리아',
    BF: '부르키나파소',
    BI: '부룬디',
    KH: '캄보디아',
    CM: '카메룬',
    CA: '캐나다',
    CV: '카보베르데',
    KY: '케이맨 제도',
    CF: '중앙아프리카 공화국',
    TD: '차드',
    CL: '칠레',
    CN: '중국',
    CX: '크리스마스 섬',
    CC: '코코스 제도',
    CO: '콜롬비아',
    KM: '코모로',
    CG: '콩고',
    CD: '콩고 민주 공화국',
    CK: '쿡 제도',
    CR: '코스타리카',
    CI: '코트디부아르',
    HR: '크로아티아',
    CU: '쿠바',
    CY: '키프로스',
    CZ: '체코',
    DK: '덴마크',
    DJ: '지부티',
    DM: '도미니카',
    DO: '도미니카 공화국',
    EC: '에콰도르',
    EG: '이집트',
    SV: '엘살바도르',
    GQ: '적도 기니',
    ER: '에리트레아',
    EE: '에스토니아',
    ET: '에티오피아',
    FK: '포클랜드 제도',
    FO: '페로 제도',
    FJ: '피지',
    FI: '핀란드',
    FR: '프랑스',
    GF: '프랑스령 기아나',
    PF: '프랑스령 폴리네시아',
    GA: '가봉',
    GM: '감비아',
    GE: '조지아',
    DE: '독일',
    GH: '가나',
    GI: '지브롤터',
    GR: '그리스',
    GL: '그린란드',
    GD: '그레나다',
    GP: '과들루프',
    GU: '괌',
    GT: '과테말라',
    GN: '기니',
    GW: '기니비사우',
    GY: '가이아나',
    HT: '아이티',
    HM: '허드 맥도널드 제도',
    VA: '바티칸 시국',
    HN: '온두라스',
    HK: '홍콩',
    HU: '헝가리',
    IS: '아이슬란드',
    IN: '인도',
    ID: '인도네시아',
    IR: '이란',
    IQ: '이라크',
    IE: '아일랜드',
    IL: '이스라엘',
    IT: '이탈리아',
    JM: '자메이카',
    JP: '일본',
    JO: '요르단',
    KZ: '카자흐스탄',
    KE: '케냐',
    KI: '키리바시',
    KP: '조선민주주의인민공화국',
    KR: '대한민국',
    KW: '쿠웨이트',
    KG: '키르기스스탄',
    LA: '라오스',
    LV: '라트비아',
    LB: '레바논',
    LS: '레소토',
    LR: '라이베리아',
    LY: '리비아',
    LI: '리히텐슈타인',
    LT: '리투아니아',
    LU: '룩셈부르크',
    MO: '마카오',
    MK: '북마케도니아',
    MG: '마다가스카르',
    MW: '말라위',
    MY: '말레이시아',
    MV: '몰디브',
    ML: '말리',
    MT: '몰타',
    MH: '마셜 제도',
    MQ: '마르티니크',
    MR: '모리타니',
    MU: '모리셔스',
    YT: '마요트',
    MX: '멕시코',
    FM: '미크로네시아 연방',
    MD: '몰도바',
    MC: '모나코',
    MN: '몽골',
    MS: '몬세라트',
    MA: '모로코',
    MZ: '모잠비크',
    MM: '미얀마',
    NA: '나미비아',
    NR: '나우루',
    NP: '네팔',
    NL: '네덜란드',
    AN: '네덜란드령 안틸레스',
    NC: '누벨칼레도니',
    NZ: '뉴질랜드',
    NI: '니카라과',
    NE: '니제르',
    NG: '나이지리아',
    NU: '니우에',
    NF: '노퍽 섬',
    MP: '북마리아나 제도',
    NO: '노르웨이',
    OM: '오만',
    PK: '파키스탄',
    PW: '팔라우',
    PS: '팔레스타인 지구',
    PA: '파나마',
    PG: '파푸아뉴기니',
    PY: '파라과이',
    PE: '페루',
    PH: '필리핀',
    PN: '핏케언 제도',
    PL: '폴란드',
    PT: '포르투갈',
    PR: '푸에르토리코',
    QA: '카타르',
    RE: '레위니옹',
    RO: '루마니아',
    RU: '러시아',
    RW: '르완다',
    SH: '세인트헬레나',
    KN: '세인트키츠네비스',
    LC: '세인트루시아',
    PM: '생피에르 미클롱',
    VC: '세인트빈센트 그레나딘',
    WS: '사모아',
    SM: '산마리노',
    ST: '상투메 프린시페',
    SA: '사우디아라비아',
    SN: '세네갈',
    CS: '세르비아 몬테네그로',
    SC: '세이셸',
    SL: '시에라리온',
    SG: '싱가포르',
    SK: '슬로바키아',
    SI: '슬로베니아',
    SB: '솔로몬 제도',
    SO: '소말리아',
    ZA: '남아프리카 공화국',
    GS: '사우스조지아 사우스샌드위치 제도',
    ES: '스페인',
    LK: '스리랑카',
    SD: '수단',
    SR: '수리남',
    SJ: '스발바르 얀마옌 제도',
    SZ: '에스와티니',
    SE: '스웨덴',
    CH: '스위스',
    SY: '시리아',
    TW: '타이완',
    TJ: '타지키스탄',
    TZ: '탄자니아',
    TH: '태국',
    TL: '동티모르',
    TG: '토고',
    TK: '토켈라우',
    TO: '통가',
    TT: '트리니다드 토바고',
    TN: '튀니지',
    TR: '튀르키예',
    TM: '투르크메니스탄',
    TC: '터크스 케이커스 제도',
    TV: '투발루',
    UG: '우간다',
    UA: '우크라이나',
    AE: '아랍에미리트',
    GB: '영국',
    US: '미국',
    UM: '미국령 군소 제도',
    UY: '우루과이',
    UZ: '우즈베키스탄',
    VU: '바누아투',
    VE: '베네수엘라',
    VN: '베트남',
    VG: '영국령 버진아일랜드',
    VI: '미국령 버진아일랜드',
    WF: '왈리스 푸투나',
    YE: '예멘',
    ZM: '잠비아',
    ZW: '짐바브웨',
  },
  header: {
    mode: '모드',
  },
  accessRequest: {
    title: '접근 권한이 필요합니다',
    subtitle: '접근 권한을 요청하거나 접근 권한이 있는 계정으로 전환하세요.',
    requestBtn: '접근 요청',
    loginBtn: '로그인하여 요청',
    messagePlaceholder: '메시지 (선택사항)',
    success: '접근 요청이 성공적으로 전송되었습니다',
    error: '요청 전송에 실패했습니다. 다시 시도해 주세요.',
    sending: '전송 중...',
    signedInAs: '로그인 계정:',
    switchAccount: '계정 전환',
  },
  menubar: {
    file: {
      toast: {
        download_original_file_error: '원본 파일 다운로드에 실패했습니다.',
        no_model_file_available: '사용 가능한 모델 파일이 없습니다.',
      },
    },
    comments: '댓글',
    details: '세부 정보',
    report: '보고서',
    quotation: {
      product_information: {
        product_information: '제품 정보',
        task_information: '작업 정보',
        title_label: '제목',
        title_placeholder: '제목 입력',
        title_error: '제목을 입력하세요',
        category_label: '카테고리',
        category_placeholder: '카테고리 선택',
        category_error: '카테고리를 선택하세요',
        subcategory_label: '하위 카테고리',
        subcategory_placeholder: '하위 카테고리 선택',
        subcategory_error: '하위 카테고리를 선택하세요',
        type_label: '타입',
        subsubcategory_placeholder: '하위 카테고리 선택',
        subsubcategory_error: '유형을 선택하세요',
        product: '제품',
        reservation: '예약',
        restaurant: '레스토랑',
        hotel: '호텔',
        event: '이벤트',
        other: '기타',
        booking: '예약',
        quotation: '견적',
        description_label: '설명',
        description_placeholder: '간단한 설명 공유...',
        share_to_the_public: '대중에게 공유',
        share_to_gallery: 'O-HIVE 갤러리에 공유',
        other_category_label: '사용자 지정 카테고리',
        other_category_placeholder: '사용자 지정 카테고리 입력',
      },
      product_price: {
        product_price: '제품 가격',
        price_label: '가격',
        price_placeholder: '0.00     CAD',
        price_error: '가격을 입력하세요. 0을 입력할 수도 있습니다',
        other_cost_label: '기타 비용',
        other_cost_description_label: '기타 비용 설명',
        other_cost_description_placeholder: '기타 비용 설명 공유...',
        other_cost_placeholder: '0.00     CAD',
        policies_url_label: '정책 URL',
        policies_url_placeholder: 'URL 붙여넣기',
        gst_hst_label: 'GST/HST',
        gst_hst_placeholder: '0   %',
        total_price_label: '총 가격',
        total_price_placeholder: '0.00     CAD',
        total_price_error: '총 가격을 입력하세요. 0을 입력할 수도 있습니다.',
      },
      bom: {
        bom: '자재 및 견적서',
        add_item: '항목 추가',
        delete_confirmation: '이 항목을 삭제하시겠습니까?',
        bulk_delete_confirmation: '이 {{count}}개 항목을 삭제하시겠습니까?',
        category_management: {
          manage_grand_categories: '대분류 관리',
          manage_categories: '카테고리 관리',
          new_category_placeholder: '새 카테고리 이름',
          select_all: '모두 선택',
          total_price: '총 가격',
          currency: {
            title: '통화 선택',
            usd: 'USD',
            eur: 'EUR',
            gbp: 'GBP',
            jpy: 'JPY',
            cad: 'CAD',
            aud: 'AUD',
            cny: 'CNY',
            krw: 'KRW',
          },
        },
        table: {
          id: '항목 번호',
          drag: '드래그',
          include: '포함',
          include_placeholder: '포함하시겠습니까?',
          no: '번호',
          part_id: '부품 ID',
          part_id_placeholder: '#ID',
          product_name: '제품 이름',
          product_name_placeholder: '제품 이름 입력',
          grand_category: '대분류',
          grand_category_placeholder: '대분류 입력',
          category: '카테고리',
          category_placeholder: '카테고리 입력',
          description: '설명',
          description_placeholder: '설명 입력',
          manufacturer: '제조사',
          manufacturer_placeholder: '제조사 입력',
          address: '주소',
          address_placeholder: '주소 입력',
          model_number: '모델 번호',
          model_number_placeholder: '모델 번호 입력',
          quantity: '수량',
          quantity_placeholder: '수량 입력',
          unit_price: '단가',
          unit_price_placeholder: '20.00 USD',
          price: '가격',
          price_inclusion_guidance:
            '테이블의 체크박스를 사용하여 가격에 포함할 항목을 선택하세요',
          price_placeholder: '단가 x 수량',
          product_link: '제품 링크',
          product_link_placeholder: '제품 링크 입력',
          tag: '태그',
          tag_placeholder: '태그 입력',
          imageID: '이미지 ID',
          imageID_placeholder: '이미지 ID 입력',
        },
      },
      business_information: {
        point_of_contact: '연락처',
        first_name_label: '이름',
        first_name_placeholder: '이름 입력',
        last_name_label: '성',
        last_name_placeholder: '성 입력',
        business_information: '비즈니스 정보',
        contact_information: '연락처 정보',
        business_address_label: '사업장 주소',
        business_address_placeholder: '회사 주소 입력',
        business_address_error: '사업장 주소를 입력하세요',
        detailed_address_label: '상세 주소',
        detailed_address_placeholder: '상세 주소 입력',
        phone_label: '전화번호',
        phone_placeholder: '전화번호 입력',
        phone_error: '유효한 전화번호를 입력하세요',
        email_address_label: '이메일 주소',
        email_address_placeholder: '이메일 주소 입력',
        email_address_error: '유효한 이메일 주소를 입력하세요',
        social_media_urls: '소셜 미디어 URL',
        facebook_url_placeholder: 'Facebook URL 입력',
        linkedin_url_placeholder: 'LinkedIn URL 입력',
        youtube_url_placeholder: 'YouTube URL 입력',
        instagram_url_placeholder: 'Instagram URL 입력',
        tiktok_url_placeholder: 'TikTok URL 입력',
        other_links: '기타 링크',
        add_link: '링크 추가',
        link_name_placeholder: '링크 이름 입력',
        link_url_placeholder: '링크 URL 입력',
      },
      social_media: {
        facebook_label: 'Facebook',
        linkedin_label: 'LinkedIn',
        youtube_label: 'YouTube',
        instagram_label: 'Instagram',
        tiktok_label: 'TikTok',
      },
      buyer: {
        title_label: '제목',
        title_placeholder: '제목 입력',
        title_error: '제목을 입력하세요',
        fname_label: '이름',
        fname_placeholder: '이름 입력',
        fname_error: '이름을 입력하세요',
        lname_label: '성 이름',
        lname_placeholder: '성 입력',
        address_label: '주소',
        address_placeholder: '여기에 주소 입력',
        address_error: '여기에 주소를 입력하세요',
        description_label: '설명',
        description_placeholder: '설명 입력',
        phone_label: '휴대폰 번호',
        phone_placeholder: '휴대폰 번호 입력',
        email_label: '이메일 주소',
        email_placeholder: '이메일 주소 입력',
        submit_request: '요청 제출',
      },
      point_of_contact: {
        address_label: '연락처 주소',
      },
      loading_pdf: 'PDF 로딩중...',
      export_pdf: 'PDF로 내보내기',
      product_quotation: '제품 견적서',
      untitled: '제목 없는 견적서',
      no_data_to_export: '내보낼 견적 데이터가 없습니다',
      generating_pdf: 'PDF 생성 중...',
      pdf_exported: 'PDF를 성공적으로 내보냈습니다',
      pdf_font_error:
        'PDF 폰트 로딩 오류입니다. 페이지를 새로고침하고 다시 시도해 주세요.',
      pdf_export_error: 'PDF 생성 중 오류가 발생했습니다. 다시 시도해 주세요.',
      pdf_memory_error:
        'PDF 내보내기에는 문서가 너무 큽니다. BOM 항목을 줄여보세요.',
      no_significant_data:
        '내보낼 중요한 데이터를 찾을 수 없습니다. 먼저 콘텐츠를 추가해 주세요.',
      subtotal: '소계:',
      vat: '부가세',
      show_more: '자세히 보기',
      next: '다음',
      confirmation_header: '이 견적을 진행하시겠습니까?',
      confirm_update_text: '이 기존 상업용 견적을 업데이트하려고 합니다.',
      confirm_create_text: '새 상업용 견적을 생성하려고 합니다.',
      processing_quotation: '견적 처리 중...',
      updating_quotation: '견적 업데이트...',
      confirmation_success_update_header:
        '견적이 성공적으로 업데이트되었습니다',
      confirmation_success_header: '견적이 성공적으로 생성되었습니다',
      confirmation_failed_update_header: '견적을 업데이트하지 못했습니다',
      confirmation_failed_update_subheader:
        '오류가 발생했습니다, 나중에 다시 시도하세요...',
      validation_error: '필수 필드를 모두 입력하세요',
      exit: '종료',
      continue: '계속',
      proceed: '진행',
      back: '뒤로',
      submit: '제출하기',
      no_quotation:
        '프로젝트에 견적서가 아직 없습니다. 견적서를 생성하거나 조직 관리자에게 문의하세요.',
      toast: {
        required_field_error: '필수 입력 항목을 모두 입력해 주세요: {{fields}}',
        validation_error: '다음 오류를 수정해 주세요: {{error}}',
        commercial_created: '광고가 성공적으로 생성되었습니다!',
        commercial_updated: '광고가 성공적으로 업데이트되었습니다!',
        commercial_created_fail: '광고 생성에 실패했습니다',
        commercial_updated_fail: '광고 업데이트에 실패했습니다',
        commercial_prepare_fail: '광고 데이터를 준비하는 데 실패했습니다',
        error_show_confirm_modal:
          '확인 대화 상자를 표시하는 중 오류가 발생했습니다',
      },
    },
    share: {
      share_title: '공유',
      share_task: '작업 공유',
      share_project: '프로젝트 공유',
      copy_link: '링크 복사',
      url_copied: '공유 링크가 복사되었습니다!',
      general_access: '일반 접근',
      option_restricted: '제한됨',
      option_view: '멤버',
      option_member: '멤버',
      option_manager: '매니저',
      option_admin: '관리자',
      option_edit: '관리자',
      public_private: '공개 접근 허용',
      public: '공개',
      private: '비공개',
      who_access: '접근 가능한 사용자',
      add_people: '이름이나 이메일로 사용자 추가',
      change_comment_mode: '댓글 허용',
      invite: '초대',
      restricted: '제한됨',
      revoke: '취소',
      not_invited: '아직 초대되지 않음',
      enabled: '활성화됨',
      disabled: '비활성화됨',
      enable_public_access: '공개 접근을 허용하시겠습니까?',
      enable_public_access_description_task:
        '링크가 있는 사람은 누구나 이 모델을 볼 수 있습니다. 조직의 일원이 아니더라도 접근이 가능합니다. 민감한 데이터가 공유되지 않도록 주의하세요.',
      enable_public_access_description_project:
        '조직의 모든 구성원이 이 프로젝트를 볼 수 있습니다. 민감한 데이터가 공유되지 않도록 주의하세요.',
      toast: {
        access_level_changed:
          '접근 수준이 {{level}}(으)로 성공적으로 변경되었습니다.',
        sending_invites: '초대장을 보내는 중...',
        cannot_invite_to_public_resource:
          '조직이 없으면 공개 리소스에 사용자를 초대할 수 없습니다',
        email_updated: '이메일이 성공적으로 업데이트되었습니다.',
        email_update_failed:
          '이메일 업데이트에 실패했습니다. 다시 시도해 주세요.',
        invalid_email: '유효하지 않은 이메일입니다',
        invalid_emails: '유효하지 않은 이메일: {{emails}}',
        invites_sent: '초대장이 성공적으로 전송되었습니다.',
        error_sending_invites: '초대장 전송 중 오류가 발생했습니다.',
        you_do_not_have_permission_to_invite_users:
          '사용자를 초대할 권한이 없습니다.',
        please_add_at_least_one_email:
          '최소한 하나의 이메일 주소를 추가해주세요.',
        error_sending_invites: '초대장 전송 중 오류가 발생했습니다.',
        invalid_email_format: '유효하지 않은 이메일 형식: {{email}}',
        cannot_invite_yourself_to_resource:
          '자신을 리소스에 초대할 수 없습니다.',
        email_already_invited: '{{email}}은(는) 이미 초대되었습니다.',
        email_already_in_pending_list:
          '{{email}}은(는) 이미 대기 목록에 있습니다.',
        please_add_at_least_one_email:
          '최소한 하나의 이메일 주소를 추가해주세요.',
        toggle_comments_failed: '댓글 전환에 실패했습니다. 다시 시도해 주세요.',
        comments_toggle_success: '댓글이 {{status}}되었습니다.',
        access_level_failed:
          '접근 수준 변경에 실패했습니다. 다시 시도해 주세요.',
        revoke_access_success:
          '{{email}}의 접근 권한이 성공적으로 해제되었습니다.',
        revoke_access_failed: '{{email}}의 접근 권한 해제에 실패했습니다.',
        role_update_success: '역할이 성공적으로 업데이트되었습니다.',
        role_update_failed: '역할 업데이트에 실패했습니다. 다시 시도해 주세요.',
        resource_not_found: '리소스를 찾을 수 없습니다.',
        fetch_organization_warning: '이 리소스와 연결된 조직이 없습니다.',
        fetch_organization_error:
          '조직 사용자 정보를 가져오는 데 실패했습니다. 나중에 다시 시도해 주세요.',
      },
    },
  },
  applyReset: {
    toast: {
      fail: '모델 편집 저장 실패',
      success: '모델을 편집하였습니다.',
      cancel: '3D 메시 저장 프로세스가 취소되었습니다',
      meshError: '3D 메시 오류: 모델에 유효한 삼각형이 남아 있지 않습니다!',
      cancelCrop: '메시 자르기 취소됨',
      failCrop: '메시 자르기 실패',
    },
    buffer: {
      export3d: '3D 모델 내보내는 중...',
      s3: '업로드 위치 요청 중...',
      upload: '파일 업로드 중...',
      save: '저장 완료 처리 중...',
      crop: '모델 자르는 중...',
    },
  },
  sidebar: {
    threads: '스레드',
    camera: '카메라',
    files: {
      title: '파일',
      delete_title: '객체 삭제',
      delete_description:
        '선택한 객체를 삭제하려고 합니다. 이 작업은 되돌릴 수 없습니다.',
      uploaded: '업로드됨',
      size: '크기',
      add_file: '파일 추가',
      empty_list: '아직 업로드된 파일이 없습니다',
    },
    details: {
      title: '세부 정보',
      objects: {
        title: '객체',
        delete_object: '객체 삭제',
      },
      cameras: {
        title: '카메라',
      },
    },
    reply: {
      add_mention: '멘션',
      add_attachments: '첨부 파일',
      check_ai_assistant: 'AI 어시스턴트',
      post: '포스트',
    },
    comments: {
      title: '댓글',
      add_title: '댓글 제목 추가',
      empty: '댓글 없음',
      search_empty: '댓글을 찾을 수 없습니다',
      add_placeholder: '댓글 입력...',
      add: '댓글',
      edit: '댓글 편집',
      delete: '댓글 삭제',
      reply: '답장',
      search_placeholder: '태그 및 댓글 검색',
      add_tag: '태그 추가',
      single_comment: '댓글',
      many_comments: '댓글',
      disabled: '댓글 비활성화됨',
      disabled_note: '다른 사용자는 댓글을 달 수 없습니다',
      no_access: '댓글에 액세스할 수 없습니다',
      single_reply: '답장 보기',
      many_replies: '답장 보기',
      replies: {
        edit: '답장 편집',
        delete: '답장 삭제',
      },
      tasks: {
        backlog: '할 일',
        inprogress: '진행 중',
        inreview: '검토 중',
        complete: '완료',
        dropped: '포기 됨',
      },
      task_statusmarker: '상태 마커',
      task_assignedto: '담당자',
      task_assignees: '담당자',
      task_duedate: '마감일',
      task_due: '마감',
      task_istask: '작업으로 처리',
      task_nomemberfound: '회원을 찾을 수 없음',
      filter: {
        title: '필터',
        people: '사람',
        deadline: '마감일',
        status: '상태',
        tag: '태그',
        clear: '필터 초기화',
        apply: '필터 적용',
        orderBy: '정렬 기준',
        orderDirection: '정렬 방향',
        asc: '오래된 순',
        desc: '최신 순',
      },
    },
    tags: {
      title: '태그',
    },
    reports: {
      createTitle: '보고서 생성',
      editTitle: '보고서 편집',
      description:
        '보고서 세부 사항을 입력하세요. * 표시된 필드는 보고서에 대한 정보를 입력해야 합니다.',
      createdAt: '생성일',
      updatedAt: '수정일',
      mandatory: '필수',
      attachFile: '라이브러리에서 파일 첨부',
      generate: '보고서 데이터 수집',
      generate_newrep: '보고서 기록',
      generating: '수집 중',
      no_assignee: '멤버가 할당되지 않았습니다',
      save: '보고서 저장',
      create_report: '보고서 저장',
      history_report: '보고서 기록 확인',
      unknown: '알 수 없음',
      hint: '힌트: "이 페이지"는 이 페이지의 작업을 표시합니다. "모든 작업"은 전체 프로젝트 내의 작업을 포함합니다.',
      hint_2:
        '힌트: 보고서를 생성하면 태그에 있는 작업 수를 확인할 수 있습니다.',
      subtitle: {
        no_results_found: '결과를 찾을 수 없음',
        no_choices: '선택할 옵션이 없음',
        press_to_select: '선택하려면 클릭하세요',
        only_unique_values: '유일한 값만 추가할 수 있습니다',
        only_matching: '특정 조건에 맞는 값만 추가할 수 있습니다',
      },
      status: {
        inBacklog: '대기 중',
        inProgress: '진행 중',
        inReview: '검토 중',
        complete: '완료',
        dropped: '중단됨',
      },
      tasks: {
        alltasks: '모든 작업',
        currtasks: '이 페이지',
      },
      types: {
        default: '-',
        body: '신체 분석',
        pose: '자세 분석',
        progress: '진행 분석',
      },
      keyPoints: {
        on: '켜짐',
        off: '꺼짐',
      },
      labels: {
        title: '제목',
        subtitle: '부제목',
        description: '설명',
        session: '세션',
        attachments: '첨부파일',
        status: '상태',
        dueDate: '마감일',
        reportType: '보고서 유형',
        gender: '성별',
        age: '나이',
        weight: '체중',
        height: '신장',
        volume: '부피',
        waist: '허리',
        torsoHeight: '몸통 높이',
        shoulderLength: '어깨 너비',
        neckAngle: '목 각도',
        leftArmLength: '왼팔 길이',
        rightArmLength: '오른팔 길이',
        waistToKneeLeftLength: '허리부터 무릎까지 (왼쪽)',
        waistToKneeRightLength: '허리부터 무릎까지 (오른쪽)',
        waistToToeLeftLength: '허리부터 발끝까지 (왼쪽)',
        waistToToeRightLength: '허리부터 발끝까지 (오른쪽)',
        chatGpt: 'AI 분석',
        keyPoints: '핵심 포인트',
        shoulderAngleLeft: '어깨 각도 (왼쪽)',
        hipAngleLeft: '엉덩이 각도 (왼쪽)',
        shoulderAngleRight: '어깨 각도 (오른쪽)',
        hipAngleRight: '엉덩이 각도 (오른쪽)',
        elbowAngleLeft: '왼쪽 팔꿈치 각도',
        elbowAngleRight: '오른쪽 팔꿈치 각도',
        kneeAngleLeft: '왼쪽 무릎 각도',
        kneeAngleRight: '오른쪽 무릎 각도',
        waistAngleLeft: '허리 각도 (왼쪽)',
        waistAngleRight: '허리 각도 (오른쪽)',
        backlog: '대기 중',
        progress: '진행 중',
        review: '검토 중',
        complete: '완료',
        dropped: '중단됨',
      },
      placeholders: {
        title: '보고서 제목',
        subtitle: '보고서 부제목',
        description: '보고서 설명',
        assignee: '멤버 이름',
        dueDate: 'YYYY/MM/DD',
        age: '나이 추가',
        weight: '체중 추가',
        height: '신장 추가',
        volume: '부피 추가',
        task: '',
        backlog: '대기 중',
        progress: '진행 중',
        review: '검토 중',
        complete: '완료',
        dropped: '중단됨',
      },
      toast: {
        report_saved: {
          title: '보고서 저장',
          description: '보고서 "{{title}}"이(가) 성공적으로 저장되었습니다.',
        },
        validate_report_error: {
          description:
            '오류가 발생했습니다: {{culprit}}이(가) 올바르게 입력되었는지 확인하세요.',
        },
      },
    },
    quotations: {
      title: '제품 세부 정보',
      editTitle: '제품 세부 정보 편집',
    },
    aiAnalyzer: {
      title: 'O-HIVE AI 어시스턴트',
      assistant: '어시스턴트',
      no_access: '라벨 생성에 대한 접근 권한이 없습니다',
      // textarea_placeholder: '컨텍스트 추가 (#), 명령어 (/)',
      textarea_placeholder: '명령어 (/)',
      chat_placeholder: '무엇이든 물어보세요...',
      new_chat: '새 채팅',
      loading_text: '분석 중',
      mode: {
        work: '워크스페이스',
        work_description: '앱 내 작업, 파일 및 작업에 적합합니다.',
        chat: '채팅 모드',
        chat_description: '질문, 아이디어 및 일상적인 도움에 적합합니다.',
        detect: '감지',
        detect_description: '프로젝트 이미지에서 시각 감지를 실행합니다.',
      },
      detect_placeholder: '감지할 내용을 설명하세요',
      detect: {
        select_image: '이미지 선택',
        change_image: '이미지 변경',
        upload_image: '이미지 업로드',
        select_from_project: '프로젝트에서 선택',
        no_image: '감지를 실행하기 전에 이미지를 선택하세요.',
        no_sequence: '감지를 실행하기 전에 시퀀스를 만들거나 선택하세요.',
        no_prompt: '감지할 내용을 설명하세요.',
        result: 'Spatial Vision 결과',
        error: '감지에 실패했습니다. 다시 시도해 주세요.',
      },
      quick_images: {
        current_task: '현재 작업의 이미지',
        current_project: '현재 프로젝트의 이미지',
      },
      search_pdf: 'PDF 검색',
      projects_selected: '{{count}}개 프로젝트 선택됨',
      tasks_selected: '{{count}}개 작업 선택됨',
      no_projects_found: '검색 조건에 맞는 프로젝트가 없습니다',
      no_projects_available: '사용 가능한 프로젝트가 없습니다',
      no_tasks_found: '검색 조건에 맞는 작업이 없습니다',
      no_tasks_in_project: '이 프로젝트에 사용 가능한 작업이 없습니다',
      tasks_not_loaded: '작업을 불러오려면 탐색하세요',
      task_count: '{{count}}개 작업',
      no_organization_projects: '조직 프로젝트가 없습니다',
      no_pdf_found: '검색과 일치하는 PDF 파일이 없습니다',
      no_pdf_projects: '{{activeTab}} 프로젝트에 PDF 파일이 없습니다',
      files_selected_limit: '최대 10개의 파일을 선택할 수 있습니다.',
      time_unit: {
        minutes: '분',
        seconds: '초',
      },
      loading_text_estimated: '예상 시간',
      pdfExport: {
        title: 'PDF 내보내기 옵션',
        blueprint: '블루프린트',
        blueprint_desc: '기본 생성된 블루프린트 SVG를 포함합니다.',
        isometric: '아이소메트릭 보기',
        isometric_desc: '활성 모델의 렌더링 PNG 보기를 포함합니다.',
        no_model: '활성 3D 모델이 필요합니다.',
        export: 'PDF 내보내기',
        exporting: '내보내는 중...',
      },
      toast: {
        download_success: 'PDF가 성공적으로 다운로드되었습니다',
        download_error: 'PDF 다운로드 실패',
        blueprint_export_warning:
          '블루프린트 생성에 실패했습니다. PDF는 해당 항목 없이 계속 생성됩니다.',
        isometric_export_warning:
          '아이소메트릭 보기 생성에 실패했습니다. PDF는 해당 항목 없이 계속 생성됩니다.',
        no_files_selected: '선택된 파일이 없습니다',
        error: '요청 처리 중 오류가 발생했습니다',
        no_prompt: '프롬프트를 작성하세요',
        bookmark_created: '북마크가 성공적으로 생성되었습니다',
        copy_table_success: '테이블 내용이 성공적으로 복사되었습니다',
        copy_message_success: '메시지가 성공적으로 복사되었습니다',
        failed_to_refresh_bookmarks: '북마크를 새로 고치는 데 실패했습니다',
        failed_to_load_bookmarks: '북마크를 불러오는 데 실패했습니다',
        failed_to_load_history: '히스토리를 불러오는 데 실패했습니다',
        max_files_exceeded: '최대 파일 수를 초과했습니다',
        insufficient_credits: '크레딧이 부족합니다',
        insufficient_credits_text:
          '당신은 {{credits}} 크레딧을 보유하고 있습니다. AI 분석기를 실행하려면 최소 2 크레딧이 필요합니다.',
      },
      show_all: '전체 보기',
      tabs: {
        chat: '채팅',
        history: '히스토리',
        bookmarks: '북마크',
      },
      tooltip: {
        download: 'PDF로 내보내기',
        bookmark: '북마크',
        copy_table: '테이블 내용 복사',
        copy_message: '클립보드에 복사',
      },
      history_empty: '사용 가능한 채팅 히스토리가 없습니다',
      bookmarks_empty: '사용 가능한 북마크가 없습니다',
      remove_bookmark_confirm: '이 북마크를 제거하시겠습니까?',
      remove_thread_confirm: '이 스레드를 제거하시겠습니까?',
      messages_count: '메시지: {{count}}',
      select_all: '모두 선택',
      deselect_all: '모두 선택 해제',
      no_search_results: '검색 결과가 없습니다',
      credits_used: '사용된 크레딧: {{credits}}',
      welcome_screen: {
        welcome_message: '안녕하세요, 무엇을 도와드릴까요?',
        // welcome_message:
        //   '안녕하세요, 무엇을 도와드릴까요? O-HIVE에 요청하여 프로젝트 관리 작업을 수행할 수 있습니다.',
        tools: {
          project: {
            title: '프로젝트',
            create_project: '새 프로젝트 생성: ',
            create_task: '새 작업 생성: ',
            create_custom_column: '새 사용자 정의 열 생성: ',
            create_task_report: '작업 보고서 생성: ',
          },
          files: {
            title: '문서',
            summarize: '선택한 파일 요약하기',
            create_report: '선택한 파일로 보고서 만들기',
            compare_files: '선택한 파일 비교하기',
          },
        },
        chat_tools: {
          general: {
            title: '일반',
            explain: '개념을 설명해 주세요',
            brainstorm: '아이디어 브레인스토밍 도와주세요',
            summarize: '정보를 요약해 주세요',
          },
          shopping: {
            title: '쇼핑',
            product_recommendation: '나를 위한 제품 추천',
            price_comparison: '가격 비교',
            deal_finding: '최고의 거래 찾기',
          },
          travel: {
            title: '여행',
            flights: '항공편 찾기',
            hotels: '호텔 찾기',
            places: '방문할 장소 추천',
          },
        },
      },
      voice_recognition: {
        mic_tooltip_idle: '음성 입력 (클릭하여 녹음 시작/중지)',
        mic_tooltip_recording: '녹음 중... (클릭하여 중지)',
        mic_tooltip_start: '음성 입력 (클릭하여 녹음 시작)',
        error_access_denied:
          '마이크 접근이 거부되었습니다. 음성 인식을 사용하려면 마이크 접근을 허용해주세요.',
        error_no_speech: '음성이 감지되지 않았습니다. 다시 시도해주세요.',
        error_network: '음성 인식 중 네트워크 오류가 발생했습니다.',
        error_recognition_failed:
          '음성 인식에 실패했습니다. 다시 시도해주세요.',
        error_not_supported: '이 브라우저에서는 음성 인식이 지원되지 않습니다.',
        error_start_failed:
          '음성 인식을 시작하는데 실패했습니다. 다시 시도해주세요.',
      },
    },
  },
  toolbar: {
    home: '홈',
    capture: '캡처',
    cursor: '커서',
    select: '선택',
    rotateleft: '왼쪽으로 회전',
    rotateright: '오른쪽으로 회전',
    translate: '이동',
    rotate: '회전',
    scale: '크기 조정',
    measure: '측정',
    tagDist: '태그 측정',
    tag: '태그',
    label: '표지',
    topview: '상(평)면도',
    frontview: '정면도',
    rightview: '우측보기',
    rearview: '후면보기',
    draw: {
      title: '그리기',
      color: '색상',
      line: '선',
      draw: '그리기',
      manage: '편집',
      clearConfirm: '모든 그림을 지우시겠습니까?',
    },
    robot: '로봇',
    crop: '자르기',
    tag_distance: '태그 거리',
    volume: '부피 측정',
    expand_tools: '도구 확장',
    collapse_tools: '도구 축소',
    measurescale: '척도 측정',
    immersion: '몰입 모드',
    blueprint: '블루프린트',
  },
  modal: {
    tag: {
      add_title: '태그 설명 추가',
      add_helper: '태그에 댓글, 파노라마 또는 링크 추가하기',
      tag_name: '태그 이름',
      tag_name_placeholder: '태그 이름',
      comment_title: '코멘트',
      panorama_title: '파노라마',
      comment_placeholder: '댓글 입력',
      link_placeholder: '링크 입력',
      edit_title: '태그 수정',
      delete_title: '태그 삭제',
      add: '태그 추가',
      update: '태그 업데이트',
      delete: '태그 삭제',
      delete_question: '이 태그를 삭제하시겠습니까?',
      delete_nb_comments: '이 태그에 연결된 {{nb}}개의 코멘트가 있습니다.',
      upload_panorama: '파노라마 업로드',
    },
    comment: {
      add_comment_placeholder: '코멘트 추가',
      delete_question: '코멘트를 삭제하시겠습니까?',
      reply_delete_question: '답장을 삭제하시겠습니까?',
    },
    immersion: {
      title: '몰입 모드를 종료하시겠습니까?',
      msg: '몰입 모드를 종료하고 CAD 뷰어로 돌아가시겠습니까?',
      disconnect_msg: ' 그러면 멀티플레이어 연결이 끊어집니다.',
      loading: {
        avatar: '3D 아바타 준비 중...',
      },
    },
    taskDownload: {
      title: '모델 다운로드',
      text: '다운로드할 모델을 선택해주세요.',
      download: '다운로드',
      downloading: '다운로드 중',
      download_error: '모델 다운로드에 실패했습니다.',
      no_models: '다운로드할 수 있는 모델이 없습니다',
      unknown_size: '알 수 없는 크기',
    },
    joinCreateOrg: {
      title: '조직 가입 또는 생성',
      join_tab: '조직 가입',
      create_tab: '조직 생성',
      join_description: '기존 조직에 가입을 요청하려면 조직 ID를 입력하세요.',
      join_explanation: '기존 멤버나 관리자로부터 조직 ID를 받을 수 있습니다.',
      create_description: '새 조직을 생성하고 관리자가 되세요.',
      org_id_label: '조직 ID *',
      org_id_placeholder: '조직 ID 입력',
      org_name_label: '조직 이름 *',
      org_name_placeholder: '조직 이름 입력',
      logo_label: '조직 로고 (선택사항)',
      message_label: '추가 메시지 (선택사항)',
      message_placeholder: '조직 관리자에게 보낼 메시지를 추가하세요...',
      send_request: '가입 요청 보내기',
      create_org: '조직 생성',
      sending_request: '요청 보내는 중...',
      creating: '생성 중...',
      logo_formats: '• 지원 형식: PNG, JPG, GIF',
      logo_size: '• 권장 크기: 512x512px 이상',
      logo_uploaded: '로고가 성공적으로 업로드되었습니다',
      invalid_image: '유효한 이미지 파일을 선택하세요',
      enter_org_id: '조직 ID를 입력하세요',
      enter_org_name: '조직 이름을 입력하세요',
      request_sent:
        '가입 요청이 성공적으로 전송되었습니다! 승인되면 알림을 받게 됩니다.',
      request_failed:
        '가입 요청 전송에 실패했습니다. 조직 ID를 확인하고 다시 시도하세요.',
      org_created: '조직이 성공적으로 생성되었습니다!',
      org_exists: '같은 이름의 조직이 이미 존재합니다',
      user_has_org: '이미 조직을 보유하고 있습니다',
      create_failed: '조직 생성에 실패했습니다',
      request_error: '요청 전송 중 오류가 발생했습니다',
      create_error: '조직 생성 중 오류가 발생했습니다',
    },
    rolesModal: {
      title: '조직 역할 세부 정보',
      role: '역할',
      description: '설명',
      current: '현재',
      adminDescription: '전체 액세스, 권한 재정의',
      managerDescription: '전체 작업 액세스, 권한 재정의',
      memberDescription: '조직 내 파일 액세스, 사용자 초대',
    },
    blueprint: {
      generate: '생성',
      description:
        '현재 모델의 2D 청사진을 생성합니다. 이 기능은 방이나 건물 내부가 아닌 다른 3D 객체에서는 작동하지 않을 수 있습니다.',
      meshError: '오류: 메쉬를 찾을 수 없습니다.',
      loadingModel: '모델 준비 중',
      loadingRay: '레이 그리드 계산 중',
      loadingRaycast: '레이캐스팅 중',
      loadingLines: '라인 생성 중',
      loadingBatch: '배치 처리 중: ',
      calculating: '계산 중...',
      generating: '블루프린트 생성 중...',
      estimate: '예상 소요 시간: ',
      warning:
        '경고: 레이 개수가 너무 많으면 디바이스 메모리를 과도하게 사용할 수 있습니다!',
      seconds: ' 초',
      error: '오류',
      horizontalName: '가로 분할 수',
      verticalName: '세로 분할 수',
      horizontalDesc:
        '분할 수가 많을수록 기둥 같은 얇은 물체를 더 정밀하게 감지할 수 있습니다.',
      verticalDesc:
        '분할 수가 많을수록 테이블 같은 평평한 물체를 더 정밀하게 감지할 수 있습니다.',
      stepSizeName: '최소 이동 간격',
      stepSizeDesc:
        '값이 작을수록 더 세밀하게 스캔하지만, 생성 속도가 느려집니다.',
      save: '블루프린트를 작업에 저장',
      download: '블루프린트 다운로드',
    },
    move: {
      title: '작업 이동',
      allOrganizations: '모든 조직',
      no_projects: '이동할 수 있는 프로젝트가 없습니다',
      loading: '프로젝트 로딩 중...',
      error: '프로젝트를 불러오는 중 오류가 발생했습니다. 다시 시도해 주세요.',
      moving: '이동 중...',
    },
  },
  spaceModal: {
    welcome_message: '안녕하세요 {{name}}님! 오늘은 무엇을 하고 싶으신가요?',
    options: {
      collaboration: '협업',
      robotics: '로봇공학',
      later: '나중에 결정할게요',
    },
    settings: '언제든지 설정에서 변경할 수 있습니다.',
  },
  resolutions: {
    original: '원본',
    mobile: '모바일',
    medium: '중간',
  },
  panorama: {
    attachment_error: '문제가 발생했습니다.',
  },
  detection: {
    sendDialog: {
      dialog:
        '{{dataType}} 모델 "{{modelName}}"(으)로 {{labels}}개의 {{labelText}}, {{images}}개의 {{imageText}} 전송 중',
    },
    label: {
      singular: '레이블',
      plural: '레이블들',
    },
    image: {
      singular: '이미지',
      plural: '이미지들',
    },
    object: {
      singular: '객체',
      plural: '객체들',
    },
    toast: {
      noImagesSelected: '처리할 이미지가 선택되지 않았습니다.',
      selectModelFirst: '먼저 드롭다운에서 모델을 선택해주세요.',
      noObjectsFound:
        '검색이 완료되었지만 선택한 이미지에서 객체를 찾지 못했습니다.',
      detectionSuccess: '{{count}}개의 이미지 검색 성공',
      processCancelled: '검색 프로세스가 취소되었습니다.',
      processingError: '처리 중 알 수 없는 오류가 발생했습니다.',
      noObjectsForImage: '{{imageId}} 이미지에서 객체를 찾지 못했습니다.',
      noValidObjects: '유효한 겹치지 않는 객체를 찾지 못했습니다.',
      objectsAdded: '{{count}}개의 객체가 이미지에 추가되었습니다',
      clearingDetections: '이전 {{count}}개의 검색 결과를 삭제 중...',
      no_upload: '업로드할 라벨된 이미지가 없습니다.',
      upload_success: '학습 데이터 업로드가 완료되었습니다.',
      upload_error: '업로드 실패',
      upload_cancel: '업로드 취소됨',
      model_limit_prefix: '모델 최대 한도',
      model_limit_suffix: '에 도달했습니다.',
      empty_name: '모델 이름을 입력해주세요.',
      model_exists: '모델 이름이 이미 존재합니다.',
      reserved_name:
        '"Default Yolo"는 예약된 이름입니다. 다른 이름을 선택해주세요.',
      model_limit_reached: '모델 생성 한도 도달',
      upload_failed_detail: '업로드 실패. 콘솔을 확인해주세요.',
      compressing_files: '파일 압축 중...',
      requesting_link: '업로드 링크 요청 중...',
      uploading_cloud: '클라우드 저장소에 업로드 중...',
    },
    loading: {
      addingToArchive: '이미지를 압축 파일에 추가 중...',
      compressing: '파일 압축 중...',
      requestingLink: '업로드 링크 요청 중...',
      uploading: '클라우드 저장소에 업로드 중...',
      analyzing: 'AI로 이미지 분석 중...',
    },
    ui: {
      noModelFound: '학습된 모델을 찾을 수 없습니다.',
      detectButton: '검색',
      modelSelectPlaceholder: 'AI 모델 선택',
      modelInfo: {
        type: '유형: {{type}}',
        knownClasses: '알려진 클래스: {{count}}개',
        trainedOn: '{{count}}개의 이미지로 학습됨',
        status: '상태: {{status}}',
        trainingProgress: '상태: 학습 중 ({{percent}}%)',
        uid: 'UID: {{uid}}',
      },
      imageText: '이미지',
      noClasses: '클래스를 찾을 수 없음',
    },
  },
  canvas: {
    title: '캔버스 설정',
    background: {
      background: '배경',
      title: '배경 옵션',
      base_bg: '기본 배경',
      threeSixty_bg: '파노라마 배경',
      static_bg: '스테틱 배경',
      texture_file_support:
        '지원되는 이미지 포맷: PNG, JPG, WEBP (부분 지원), GIF, BMP, TGA',
      texture_file_support_360:
        '지원되는 이미지 포맷: PNG, JPG, WEBP (부분 지원), GIF, BMP, TGA - 파노라마 (360도) 이미지를 사용하세요.',
      upload: '업로드',
      add_file: '파일 추가',
      file_success: '파일 업로드 성공',
      file_unknown: '주의: 알 수 없는 파일 포맷',
      file_none: '파일이 감지되지 않았습니다',
      base_bg_desc: '테마 설정을 따른 색상 배경',
      none_bg_desc: '배경 설정 제거',
    },
    lighting: {
      lighting: '라이팅',
      intensity: '밝기',
      visibility: '가시성',
      penumbra: '반그림자',
      angle: '각도',
      shadow: '그림자',
      distance: '거리',
      decay: '감쇠',
      position: '위치',
      rotation: '회전',
      scale: '크기',
      restore: '기본값 복원',
    },
    postProcessing: {
      renderEffects: '렌더 효과',
      postProcessing: '포스트 프로세싱',
      sceneHelpers: '씬 보조 도구',
      forceComposer: '컴포저 적용',
      grid: '격자',
      horizontal: '수평 격자',
      vertical: '수직 격자',
      adjustGrid: '모델에 그리드 조정',
    },
    presets: {
      presets: '프리셋',
      presetsOhive: 'O-HIVE 프리셋',
      presetsDesc:
        '보고 있는 작업 유형에 따라 장면의 조명과 환경 설정을 맞춤 설정하세요.',
      presetStudio: '스튜디오 조명',
      presetMidnight: '미드나이트 플래시',
      presetSnowy: '겨울 알프스',
      presetFactory: '공장 표준 조명',
    },
    toast: {
      backgroundApplied: {
        title: '배경 적용됨',
        description: '배경이 {{mode}}로 변경되었습니다.',
      },
      updateBackgroundError: {
        // title: 'Background Error',
        title: '배경 오류',
        description: '배경 업데이트 중 오류가 발생했습니다: {{error}}',
      },
      existingAmbient:
        'Ambient Light(앰비언트 라이트)가 이미 존재하며 장면 전체에 적용됩니다. 하나만 허용됩니다.',
      defaultLightingRestored: '기본 조명이 복원되었습니다.',
    },
  },
  imageViewer: {
    carousel: {
      settings: {
        playSpeed: '재생 속도:',
        playDir: '재생 방향:',
        left: '이전',
        right: '다음',
      },
    },
    uploadItems: {
      addNewItem: '현재 페이지에 파일 추가: ',
    },
    uploadImages: {
      addImages: '이미지 업로드',
      deleteSelected: '선택된 항목 삭제',
      warning: '파일 형식이 올바르지 않습니다.',
      error: '업로드 중 오류가 발생했습니다: ',
      errorAxios: '갤러리에 항목을 업로드하는 중 오류 발생: Axios 문제',
      files: '파일',
      noFiles: '업로드될 파일이 선택되지 않았습니다.',
      addFiles: '새 이미지 추가 중...',
      success: '갤러리에 이미지가 추가되었습니다: ',
      upload: '업로드',
    },
    uploadModels: {
      addModels: '3D 모델 업로드',
      deleteSelected: '선택된 항목 삭제',
      warning: '파일 형식이 올바르지 않습니다.',
      error: '업로드 중 오류가 발생했습니다: ',
      errorAxios: '갤러리에 항목을 업로드하는 중 오류 발생: Axios 문제',
      files: '파일',
      noFiles: '업로드될 파일이 선택되지 않았습니다.',
      addFiles: '모델 업로드 중...',
      success: '갤러리에 모델이 추가되었습니다: ',
      upload: '업로드',
    },
    objectDetectionFeature: {
      trainSucess: '귀하의 이미지 데이터가 학습을 위해 전송되었습니다!',
      trainError: '이 CAD 파일에 대해 학습할 태그된 이미지가 없습니다!',
      enableDetection: '자동 감지 활성화됨',
      disableDetection: '자동 감지 비활성화됨',
      defaultError: '문제가 발생했습니다',
      downloadFailure: '모델 다운로드에 실패했습니다',
    },
    unknownFileType: {
      unsupported:
        '지원되지 않는 파일 형식입니다. 미리보기를 표시할 수 없습니다.',
      download: '파일 다운로드.',
    },
    toast: {
      update_order: {
        title: '주문이 업데이트됨',
        description: '갤러리가 업데이트되었습니다.',
      },
      delete_images: {
        title: '이미지 삭제됨',
        description: '현재 파일에서 {{count}}개의 이미지를 삭제했습니다.',
      },
      delete_images_match_error: {
        title: '매칭 오류',
        description:
          '이미지 삭제 중 오류 발생: 이미지 Cad ID {imgCadId}와 스프라이트 Cad ID {spriteCadId}가 일치하지 않습니다.',
      },
    },
  },
  pages: {
    register: {
      title: 'O-HIVE에 오신 것을 환영합니다',
      subtitle: '계정을 만들려면 아래 필드를 작성하세요',
      confirm_password: '비밀번호 확인',
      sign_up: '회원가입',
      no_account: '계정이 없으신가요?',
      password_rules: {
        title: '비밀번호는 다음을 포함해야 합니다:',
        uppercase: '대문자 하나 이상',
        number: '숫자 하나 이상',
        special: '특수 문자 하나 이상',
        length: '8자 이상',
      },
      verify: {
        choose: '인증 옵션 선택',
      },
      privacy: '회원가입 시, 귀하는 우리의',
      success: '회원가입이 성공적으로 완료되었습니다! 인증 알림을 확인하세요!',
      error: '문제가 발생했습니다. 입력 내용을 확인하세요!',
    },
    login: {
      title: '다시 오신 것을 환영합니다',
      subtitle: '계속하려면 로그인하세요',
      sign_in: '로그인',
      already_have_account: '계정이 있으신가요?',
      forgot_password: '비밀번호를 잊으셨나요?',
      slogan1: '더 나은 시각화. <br /> 더 스마트한 협업.',
      slogan2:
        '시각적 협업, 3D 스캔, AI 기반 분석 및 실시간 프로젝트 관리를 위한 올인원 플랫폼',
      error: {
        credentials: '잘못된 이메일 또는 비밀번호',
        toast: '문제가 발생했습니다. 자격 증명을 확인하세요!',
      },
      success: '로그인 성공!',
    },
    forgot_password: {
      title: '비밀번호를 잊으셨나요?',
      subtitle: '걱정하지 마세요. 재설정 지침을 보내드리겠습니다!',
      send: '재설정 링크 보내기',
      success: '링크를 보냈습니다. 받은 편지함을 확인하세요!',
      error: '문제가 발생했습니다. 이메일을 확인하세요!',
    },
    reset_password: {
      title: '새 비밀번호 설정',
      subtitle: '아래에 새 비밀번호를 만드세요!',
      submit: '비밀번호 재설정',
      success: '새 비밀번호가 설정되었습니다. 다시 로그인하세요!',
      error: '문제가 발생했습니다. URL의 비밀번호와 토큰을 확인하세요!',
    },
    phone_verify: {
      slogan1: '휴대폰 인증',
      slogan2: '휴대폰으로 전송된 코드를 입력하세요.',
      header: '휴대폰 인증',
      sub_1: '다음으로 전송된 6자리 코드를 입력하세요',
      dont_get_code: '코드를 받지 못하셨나요? ',
      send_again: '다시 보내기',
      success_message: '휴대폰 인증이 성공적으로 완료되었습니다!',
      error_invalid_code: '인증 실패. 코드를 확인하세요.',
      error_incomplete_code: '6자리 코드를 모두 입력하세요.',
      error_api: '예기치 않은 오류가 발생했습니다.',
      resend_success: '인증 코드가 다시 전송되었습니다.',
      resend_error: '코드 재전송에 실패했습니다.',
    },
    email_verify: {
      slogan1: '이메일 주소 인증',
      slogan2: '아래 버튼을 클릭하여 이메일을 인증하세요.',
      header: '이메일 인증',
      verify_button: '이메일 인증하기',
      return_to_login: '로그인으로 돌아가기',
      need_help: '도움이 필요하신가요? ',
      email_copied: '지원 이메일이 복사되었습니다!',
      success: '이메일이 성공적으로 인증되었습니다!',
      error: '이메일 인증에 실패했습니다.',
      invalid_token: '유효하지 않거나 만료된 인증 링크입니다.',
      api_error: '예기치 않은 오류가 발생했습니다.',
      processing: '인증 중...',
    },
    projects: {
      project: '프로젝트',
      projects: '프로젝트들',
      task: '작업',
      tasks: '작업들',
      noDescription: '설명 없음',
      createdOn: '생성일',
      addTask: '작업 추가',
      noTasksInProject: '이 프로젝트에 작업이 없습니다',
      createNewTask: '새 작업 생성',
      noProjectsFound: '프로젝트를 찾을 수 없습니다.',
      actions: '작업',
      noItemsFound: '항목을 찾을 수 없습니다',
      nameCannotBeEmpty: '이름은 비워 둘 수 없습니다',
      taskNameIsRequired: '작업 이름이 필요합니다',
      taskCreatedSuccessfully: '작업이 성공적으로 생성되었습니다',
      failedToCreateTask: '작업 생성 실패',
      newProject: '새 프로젝트',
      backToPersonal: '내 프로젝트로 돌아가기',
      bottomActionBar: {
        selected: '{{count}}개 선택됨',
        moveTasks: '{{count}}개 작업 이동',
      },
      templates: {
        projects: {
          name: '프로젝트',
          description: '작업, 상태 추적 및 팀 배정이 포함된 일반 프로젝트 관리',
        },
        crm: {
          name: 'CRM',
          description: '연락처, 리드 및 조직을 위한 고객 관계 관리',
        },
        purchase: {
          name: '구매',
          description: '구매 주문, 공급업체, 가격 및 배송 상태 추적',
        },
        calendar: {
          name: '캘린더',
          description: '회의, 이벤트 일정 및 참석자 응답 추적',
        },
        email: {
          name: '이메일',
          description: '이메일 캠페인, 초안 및 커뮤니케이션 기록 추적',
        },
        repository: {
          name: '저장소',
          description: '파일 추적 및 접근 관리가 포함된 문서 저장소',
        },
        inventory: {
          name: '재고',
          description: '재고 항목, 재고 수준 및 공급업체 정보 추적',
        },
      },
      delete: '{{type}} 삭제',
      deleteConfirmation: '이 {{type}}를 삭제하시겠습니까?',
      hubspot: {
        notConfigured:
          '이 프로젝트에 HubSpot 동기화가 설정되지 않았습니다. 프로젝트 설정에서 설정하세요.',
        syncing: 'HubSpot과 동기화 중...',
        syncComplete: 'HubSpot 동기화가 성공적으로 완료되었습니다',
        syncFailed: 'HubSpot 동기화에 실패했습니다',
        syncError: 'HubSpot과 동기화하는 데 실패했습니다',
      },
      fileSizeLimitError: '전체 파일 크기는 {{limit}}MB를 초과할 수 없습니다.',
      onlyOneFileAllowed: '업로드할 수 있는 파일은 하나만 허용됩니다.',
      unsupportedFileType: '지원되지 않는 파일 형식: {{fileType}}.',
      columns: {
        title: '열',
        createNew: '새 열 만들기',
        add: '열 추가',
        hide: '숨기기',
        sortAsc: '오름차순 정렬',
        sortDesc: '내림차순 정렬',
        manageOptions: '옵션 관리',
        deleteTitle: '열 삭제',
        deleteConfirm: '"{{title}}" 열을 삭제하시겠습니까?',
        resize: '크기 조정',
        fixed: '고정됨',
        default: '기본값',
        custom: '사용자 정의',
        allColumns: '모든 열',
        selectedCount: '({{count}}개 선택됨)',
        search: '열 검색...',
        noColumnsFound: '열을 찾을 수 없습니다',
        reset: '열 재설정',
        moveLeft: '왼쪽으로 이동',
        moveRight: '오른쪽으로 이동',
      },
      cells: {
        select: {
          selectOption: '옵션 선택...',
          editOptions: '옵션 편집',
          deselect: '선택 해제',
        },
        people: {
          addPeople: '사용자 추가...',
          searchUsers: '사용자 검색...',
          noUsersFound: '사용자를 찾을 수 없습니다',
          unknownUser: '알 수 없는 사용자',
          failedToUpdate: '사용자 할당 업데이트 실패',
        },
        date: {
          selectDate: '날짜 선택',
        },
      },
      projectDataActions: {
        title: '데이터 도구',
        importCsv: 'CSV 가져오기',
        exportCsv: 'CSV로 내보내기',
        downloadTemplate: 'CSV 템플릿 다운로드',
        currentProjectTemplate: '현재 프로젝트',
        selectTemplateTitle: 'CSV 템플릿 다운로드',
        orSelectTemplate: '또는 템플릿 유형 선택',
        noItemsForExport: '내보낼 항목이 없습니다',
        exportedCsvFile: '{{count}}개 항목으로 CSV 파일을 내보냈습니다',
        exportFailed: '항목 내보내기에 실패했습니다',
        noFileSelected: '선택된 파일이 없습니다',
        csvDataUploadedSuccessfully:
          'CSV 데이터가 성공적으로 업로드되었습니다!',
        failedToUploadCsvData: 'CSV 데이터 업로드에 실패했습니다',
        noValidDataFound: 'CSV 파일에서 유효한 데이터를 찾을 수 없습니다',
        failedToProcessColumnSelection: '컬럼 선택 처리에 실패했습니다',
        failedToParseCSV: 'CSV 파일 파싱에 실패했습니다',
        failedToUploadProjectsAndColumnData:
          '프로젝트 및 컬럼 데이터 업로드에 실패했습니다',
        csvUploadRequirements: 'CSV 업로드 요구사항',
        csvUploadDescription:
          'CSV 파일에 "Name"이라는 "텍스트" 타입의 헤더 컬럼이 있는지 확인하세요. 이 컬럼은 필수이며 모든 이름은 고유하고 비어있지 않아야 합니다.',
        continue: '계속',
        supportedFileTypes: '지원되는 파일 형식: .csv',
        missingColumnsDetected: '누락된 컬럼 감지됨',
        missingColumnsDescription:
          'CSV의 다음 컬럼들이 이 프로젝트에 존재하지 않습니다. 새로 만드시겠습니까?',
        selectAll: '모두 선택',
        type: '타입: {{type}}',
        selectColumnsToCreate: '생성할 컬럼 선택',
        continueToPreview: '미리보기로 계속',
        skipAllMissingColumns: '누락된 컬럼 모두 건너뛰기',
        confirmCsvUpload: 'CSV 업로드 확인',
        columnsToBeCreated: '생성될 컬럼',
        skippedColumns: '건너뛴 컬럼',
        createColumnsAndUpload: '컬럼 생성 및 {{count}} 업로드',
        upload: '{{count}} 업로드',
        uploadDescription: '{{count}}를 업로드합니다.',
        createColumnsDescription:
          '{{count}}개의 새 컬럼{{plural}}을 생성하고 {{uploadCount}}를 업로드합니다.',
        newColumnHeader: '✨ {{header}} [새로운 컬럼]',
        usersAssigned: '{{count}}명의 사용자{{plural}} 할당됨',
        invalidUserData: '잘못된 사용자 데이터',
        csvMustHaveTwoHeaderRows:
          'CSV 파일은 최소 두 개의 헤더 행(이름과 타입)이 있어야 합니다',
        csvMustContainHeadersAndTypes:
          'CSV 파일은 헤더와 타입을 포함해야 합니다',
        invalidColumnType:
          '잘못된 컬럼 타입 "{{type}}". 유효한 타입: {{validTypes}}. CSV 파일이 올바르게 형식화되었는지 확인하세요.',
        personalProjectsCannotHavePeopleColumns:
          '개인 프로젝트는 "사람" 타입 컬럼을 가질 수 없습니다',
        csvMustContainNameColumn:
          'CSV 파일은 "Name" 컬럼을 포함해야 합니다. 이 컬럼은 프로젝트/작업 생성에 필수입니다.',
        nameColumnMustBeText: '"Name" 컬럼은 "text" 타입이어야 합니다.',
        nameColumnValidationFailed: 'Name 컬럼 검증 실패:\n{{errors}}',
      },
      modals: {
        move: {
          title: '작업 이동',
          myProjects: '내 프로젝트',
          allOrganizations: '모든 조직',
          noProjects: '이동할 수 있는 프로젝트가 없습니다',
          loading: '프로젝트 로드 중...',
          error: '프로젝트 로드 중 오류가 발생했습니다. 다시 시도하십시오.',
          moving: '이동 중...',
          move: '이동',
          permissionOrSubscriptionMissing:
            '이 조직에 대한 권한 또는 구독이 없습니다.',
        },
        createProject: {
          title: '새 프로젝트 만들기',
          placeholder: '프로젝트 이름 입력',
          projectName: '프로젝트 이름',
          selectTemplate: '템플릿 선택',
          loadingTemplates: '템플릿 로드 중...',
          errorEmpty: '프로젝트 이름은 비워 둘 수 없습니다',
          errorCreate: '프로젝트 생성 실패: {{error}}',
          syncHubSpot: 'HubSpot과 동기화',
          hubspot: {
            syncInfo: 'HubSpot의 연락처가 이 프로젝트로 가져와집니다.',
            connectedTo: '연결됨: {{portalName}}',
            syncing: 'HubSpot에서 연락처 가져오는 중...',
            syncComplete: 'HubSpot에서 연락처를 성공적으로 가져왔습니다',
            syncFailed: '다음 수동 동기화 시 연락처가 동기화됩니다',
            syncConfigFailed:
              '프로젝트가 생성되었지만 HubSpot 동기화 설정에 실패했습니다',
          },
        },
        selectOptions: {
          newLabel: '새 라벨',
          editTitle: '"{{title}}" 옵션 편집',
          saveChanges: '변경 사항 저장',
          addNewLabel: '새 라벨 추가',
          deactivate: '비활성화',
          activate: '활성화',
          updateSuccess: '옵션이 성공적으로 업데이트되었습니다!',
          updateFailed: '옵션 업데이트 실패: {{error}}',
        },
        taskDownload: {
          title: '모델 다운로드',
          download: '다운로드',
          downloading: '다운로드 중',
          error: '모델 다운로드 실패.',
          noModels: '다운로드할 수 있는 모델이 없습니다',
          unknownSize: '알 수 없는 크기',
        },
      },
      uploadTask: '새 작업 업로드:',
      taskName: '작업 이름',
      dragAndDrop: '파일을 찾아보거나 여기에 끌어다 놓으세요',
      uploading: '업로드 중...',
      supportedTaskFiles:
        '지원되는 파일 형식: glb, gltf, stl, step, jpg, png, webp, mp4, mov, pdf',
      paywall: {
        admin_message:
          '조직 관리자에게 문의하여 팀 프로젝트에 접근할 수 있도록 업그레이드해 주세요.',
        cta_button: '팀 기능 사용을 위해 업그레이드',
        no_access_message:
          '결제 관리 권한이 없습니다. 구독을 업그레이드하려면 조직 관리자에게 문의해 주세요.',
        max_reached: {
          heading: '구독 좌석 한도 도달',
          description:
            '조직이 현재 구독 플랜에서 허용하는 최대 사용자 수에 도달했습니다. 더 많은 팀 멤버를 추가하려면 구독을 업그레이드해 주세요.',
          button_text: '구독 업그레이드',
          admin_message:
            '조직이 사용자 한도에 도달했습니다. 구독 플랜을 업그레이드하려면 관리자에게 문의해 주세요.',
          no_access_message:
            '조직이 사용자 한도에 도달했습니다. 구독 플랜을 업그레이드하려면 관리자에게 문의해 주세요.',
        },
        subscription_required: {
          heading: '팀 프로젝트에는 구독이 필요합니다',
          description:
            '팀 프로젝트에 액세스하고 조직과 협업하려면 활성 구독이 필요합니다.',
        },
        pending_approval: {
          title: '승인 대기 중',
          message:
            '이 조직에 가입 요청이 관리자에게 전송되었습니다. 승인을 기다려 주세요.',
        },
        leave_confirmation: {
          title: '조직 탈퇴',
          message:
            '"{{name}}"에서 탈퇴하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
        },
      },
      noProjectsFound:
        '프로젝트가 없습니다. 첫 번째 프로젝트를 생성해 시작해보세요!',
      noProjectsFoundUser:
        '팀 프로젝트에 접근할 수 없습니다. 관리자에게 문의하여 초대를 받아 주세요.',
      guidance_message: '왼쪽의 프로젝트 목록에서 작업을 선택해 주세요.',
      reset_column_order: '열 순서 재설정',
      reset_column_order_confirm:
        '정말 열 순서를 재설정하시겠습니까? 정렬, 크기, 열 순서 설정이 모두 초기화됩니다.',
      no_actions: '이 선택에 사용할 수 있는 작업이 없습니다',
      toast: {
        add_project: '프로젝트가 성공적으로 추가되었습니다.',
        add_project_error: '프로젝트 추가에 실패했습니다.',
        delete_project: '프로젝트가 성공적으로 삭제되었습니다.',
        delete_project_error: '프로젝트 삭제에 실패했습니다.',
        rename_project: '프로젝트 이름이 성공적으로 변경되었습니다.',
        rename_project_error: '프로젝트 이름 변경에 실패했습니다.',
        empty_project_name: '프로젝트 이름을 입력해 주세요.',
        delete_task: '작업이 성공적으로 삭제되었습니다.',
        delete_task_error: '작업 삭제에 실패했습니다.',
        download_task: '모델이 성공적으로 다운로드되었습니다.',
        download_task_error: '모델 다운로드에 실패했습니다.',
        duplicate_project: '프로젝트가 성공적으로 복제되었습니다.',
        duplicate_project_error: '프로젝트가 복제에 실패했습니다.',
        duplicate_task_limit: '작업 복제는 최대 {{number}}개까지만 가능합니다.',
        duplicate_task: '작업이 성공적으로 복제되었습니다.',
        duplicate_task_error: '작업 복제에 실패했습니다.',
        move_task: '작업이 성공적으로 이동되었습니다.',
        move_task_error: '작업 이동에 실패했습니다.',
        copy_task: '작업이 성공적으로 복사되었습니다.',
        rename_task: '작업 이름이 성공적으로 변경되었습니다.',
        rename_task_error: '작업 이름 변경에 실패했습니다.',
        delete_item: '항목이 성공적으로 삭제되었습니다.',
        delete_item_error: '항목 삭제에 실패했습니다.',
        reset_view: '뷰가 기본 순서로 재설정되었습니다.',
        email_copied: {
          title: '이메일 복사됨',
          description: '이메일이 클립보드에 성공적으로 복사되었습니다.',
        },
        failed_column_update: '열 값 업데이트 실패',
        column_exists: '열 이름이 이미 존재합니다.',
      },
    },
    invitation: {
      invitation_error: '초대 오류',
      check_account: '계정을 확인해 주세요',
      go_to_projects: '프로젝트로 이동',
      sign_out_button: '로그아웃',
      invitation_process_title: '초대 프로세스',
      set_password_label: '비밀번호 설정',
      password_placeholder: '새 비밀번호를 입력하세요',
      save_password_button: '비밀번호 저장',
      process_completed: '프로세스 완료',
      go_to_team_projects: '팀 프로젝트로 이동',
      go_to_login: '로그인으로 이동',
      password_min_length: '비밀번호는 최소 5자 이상이어야 합니다',
      password_created_success: '비밀번호가 성공적으로 생성되었습니다!',
      password_creation_failed:
        '비밀번호 생성에 실패했습니다. 다시 시도해 주세요.',
    },
    SubmittedForms: {
      title: '견적서',
      no: '번호',
      type: '유형',
      description: '설명',
      firstName: '이름',
      lastName: '성',
      requestDate: '요청 날짜',
      updatedDate: '업데이트 날짜',
      status: '상태',
      toast: {
        statusUpdatedSuccessfully:
          '견적서 상태가 성공적으로 업데이트되었습니다',
        statusUpdateFailed: '견적서 상태 업데이트에 실패했습니다',
        loadFailed: '견적서를 불러오는 데 실패했습니다',
      },
    },
    help: {
      title: '도움말 및 지원',
      subtitle: '자주 묻는 질문에 대한 답변과 지원을 받으세요',
      account_management: {
        title: '계정 관리',
        delete_account: {
          title: '계정 삭제 방법',
          content:
            '계정을 삭제하려면 설정 > 계정 > 계정 삭제로 이동하세요. 이 작업은 되돌릴 수 없으며 모든 데이터가 영구적으로 삭제됩니다.',
        },
        update_info: {
          title: '계정 정보 업데이트',
          content:
            '설정 > 계정 > 프로필 편집에서 언제든지 계정 정보를 업데이트할 수 있습니다.',
        },
        password_reset: {
          title: '비밀번호 재설정',
          content:
            '비밀번호를 잊으셨다면 로그인 페이지에서 "비밀번호 찾기"를 클릭하세요. 비밀번호 재설정 방법에 대한 이메일을 받게 됩니다.',
        },
      },
      general_usage: {
        title: '일반 사용법',
        view_cad: {
          title: 'CAD 파일 보기',
          content:
            'CAD 파일을 보려면 뷰어에 끌어다 놓거나 업로드 버튼을 사용하세요. 지원되는 형식은 .dwg, .dxf, .stl입니다.',
        },
        navigation: {
          title: '탐색 컨트롤',
          content:
            '마우스를 사용하여 탐색하세요: 왼쪽 클릭으로 회전, 오른쪽 클릭으로 이동, 스크롤로 확대/축소. 모바일 기기에서도 터치 컨트롤이 지원됩니다.',
        },
        save_export: {
          title: '저장 및 내보내기',
          content:
            '뷰어 상단의 도구 모음을 사용하여 현재 보기를 저장하고 다양한 형식으로 파일을 내보낼 수 있습니다.',
        },
      },
      support: {
        title: '지원 받기',
        contact: {
          title: '지원 문의',
          content:
            '기술적 문제나 질문이 있으시면 {{email}}으로 이메일을 보내거나 문의 양식을 사용하세요.',
        },
        documentation: {
          title: '문서',
          content:
            '자세한 가이드와 튜토리얼을 보려면 문서 사이트를 방문하세요.',
        },
        community: {
          title: '커뮤니티 포럼',
          content:
            '커뮤니티 포럼에 참여하여 다른 사용자들과 연결하고 팁과 요령을 공유하세요.',
        },
      },
      privacy: {
        title: '개인정보 처리방침',
        link: {
          title: '자세히 알아보기',
          content:
            '귀하의 개인정보는 저희에게 중요합니다. 저희가 귀하의 데이터를 수집하고 사용하는 방법에 대한 정보는 개인정보 처리방침을 검토해 주시기 바랍니다.',
        },
      },
      more_help: {
        title: '더 많은 도움이 필요하신가요?',
        email: '이메일 지원',
        docs: '문서',
        forum: '커뮤니티 포럼',
      },
    },
    settings: {
      title: '설정',
      tabs: {
        personal: '개인',
        organization: '조직',
        subscription: '구독',
        settings: '설정',
      },
      header: {
        account_owner: '계정 소유자',
      },
      personal_details: {
        title: '개인 정보',
        created_at: '가입일',
        change_password: '변경',
        saving: '저장 중...',
      },
      preferences: {
        title: '환경설정',
        language: '언어',
        default_space: '기본 공간',
        select_language: '언어 선택',
        select_default_space: '기본 공간 선택',
        languages: {
          en: 'English',
          kr: '한국어',
        },
        spaces: {
          select: '공간 선택',
          collaboration: '협업',
          robotics: '로봇공학',
        },
      },
      delete_account: {
        title: '계정 삭제',
        description:
          '계정을 삭제하면 되돌릴 수 없습니다. 신중하게 결정해 주세요.',
        button: '계정 삭제',
        modal: {
          title: '계정 삭제',
          confirm_title: '정말 계정을 삭제하시겠습니까?',
          warning: '이 작업은 되돌릴 수 없습니다',
          description: '모든 데이터가 영구적으로 삭제됩니다.',
          confirm: '계정 삭제',
          deleting: '삭제 중...',
        },
      },
      organization: {
        title: '내 조직',
        subtitle: '조직 설정 및 멤버십을 관리하세요',
        create_or_join: '조직 생성 또는 가입',
        empty_state: {
          title: '조직이 없습니다',
          description:
            '첫 번째 조직을 생성하거나 기존 조직에 가입하여 시작하세요.',
          button: '조직 생성 또는 가입',
        },
      },
      modals: {
        update_password: {
          title: '비밀번호 변경',
          current_password: '현재 비밀번호',
          new_password: '새 비밀번호',
          confirm_password: '새 비밀번호 확인',
          update: '비밀번호 변경',
        },
        otp_verification: {
          title: '휴대폰 인증',
          description: '휴대폰으로 전송된 인증 코드를 입력하세요',
          verify: '인증',
        },
        edit_avatar: {
          title: '아바타 편집',
          upload_new: '새 이미지 업로드',
          save: '변경사항 저장',
          organization_description:
            '새 조직 로고 이미지를 업로드하세요. 이미지는 정사각형이어야 하며 최소 200x200 픽셀 이상이어야 합니다.',
          user_description:
            '새 아바타 이미지를 업로드하세요. 이미지는 정사각형이어야 하며 최소 200x200 픽셀 이상이어야 합니다.',
        },
        add_user: {
          title: '새 멤버 추가',
          description: '조직에 참여할 새 멤버를 초대하세요',
          role: '역할',
          first_name_placeholder: '이름 입력',
          last_name_placeholder: '성 입력',
          email_placeholder: '이메일 주소 입력',
          add_user: '사용자 추가',
          upgrade_required: '업그레이드 필요',
          upgrade_seats: '좌석 업그레이드',
          max_users_warning:
            '최대 사용자 수에 도달했습니다 ({{current}}/{{max}}). 더 많은 사용자를 추가하려면 플랜을 업그레이드하세요.',
        },
        delete_organization: {
          title: '조직 삭제',
          warning:
            '"{{name}}"을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없으며 모든 조직 데이터가 영구적으로 제거됩니다.',
          confirmation_label: '확인하려면 "DELETE"를 입력하세요:',
          confirmation_placeholder: '삭제 확인을 위해 DELETE 입력',
          confirm_delete: '조직 삭제',
          deleting: '삭제 중...',
          type_delete_error: '확인하려면 "DELETE"를 입력하세요',
        },
        subscription_confirmation: {
          title: '구독이 성공적으로 업데이트되었습니다!',
          message: '페이팔에서 구독이 성공적으로 업데이트되었습니다.',
          email_notice: '변경사항이 적용되면 이메일을 받게 됩니다.',
        },
      },
      toast: {
        info_updated: '정보가 성공적으로 업데이트되었습니다.',
        info_update_failed: '정보 업데이트에 실패했습니다. 다시 시도해 주세요.',
        invalid_fields: '저장하기 전에 잘못된 필드를 수정해 주세요.',
        language_updated: '언어 설정이 성공적으로 업데이트되었습니다',
        language_update_failed: '언어 설정 업데이트에 실패했습니다',
        space_updated: '기본 공간 설정이 성공적으로 업데이트되었습니다',
        space_update_failed: '기본 공간 설정 업데이트에 실패했습니다',
        account_deleted: '계정이 성공적으로 삭제되었습니다',
        account_delete_failed: '계정 삭제에 실패했습니다',
        otp_send_failed: 'OTP 전송에 실패했습니다. 다시 시도해 주세요.',
        general_error: '정보 업데이트 중 오류가 발생했습니다.',
        user_invited: '사용자 초대됨: {{email}}',
        user_invite_failed: '사용자 초대에 실패했습니다',
        user_role_updated: '사용자 역할이 성공적으로 업데이트되었습니다',
        user_role_update_failed: '사용자 역할 업데이트에 실패했습니다',
        user_approved: '사용자가 성공적으로 승인되었습니다',
        user_approve_failed: '사용자 승인에 실패했습니다',
        user_removed: '사용자가 성공적으로 제거되었습니다',
        user_remove_failed: '사용자 제거에 실패했습니다',
        invitation_resent: '초대장이 성공적으로 재전송되었습니다',
        invitation_resend_failed: '초대장 재전송에 실패했습니다',
        organization_updated: '조직이 성공적으로 업데이트되었습니다',
        organization_update_failed: '조직 업데이트에 실패했습니다',
        organization_deleted: '조직이 성공적으로 삭제되었습니다',
        organization_delete_failed: '조직 삭제에 실패했습니다',
        organization_left: '조직에서 성공적으로 탈퇴했습니다',
        organization_leave_failed: '조직 탈퇴에 실패했습니다',
        organization_name_required: '조직 이름이 필요합니다',
        invoice_download_failed: '청구서 다운로드에 실패했습니다',
        users_load_failed: '사용자 로드에 실패했습니다',
        upgrade_seats_info: '플랜을 업그레이드하려면 구독 탭으로 이동하세요',
        validation_errors: {
          first_name_required: '유효한 이름을 입력하세요',
          last_name_required: '유효한 성을 입력하세요',
          email_required: '유효한 이메일 주소를 입력하세요',
        },
      },
      user_management: {
        table: {
          role: '역할',
          date_joined: '가입일',
          actions: '작업',
          no_users_found: '사용자를 찾을 수 없습니다',
        },
        actions: {
          add_member: '멤버 추가',
          action_required: '작업 필요',
          pending: '대기 중',
          approve: '승인',
          deny: '거부',
          resend: '재전송',
        },
        status: {
          max_users_exceeded: '최대 사용자 수 초과 {{current}}/{{max}}',
        },
      },
      invoice_history: {
        title: '청구서',
        table: {
          date: '날짜',
          description: '설명',
          invoice_total: '청구서 총액',
          invoice: '청구서',
          download_pdf: 'PDF 다운로드',
          no_invoice: '청구서 없음',
        },
        loading: '로딩 중...',
        error: '청구서를 불러오는 중 오류가 발생했습니다. 다시 시도해 주세요.',
        no_billing_history: '이용 가능한 청구 내역이 없습니다',
        no_invoices: '이용 가능한 청구서가 없습니다',
        generating_pdf: '청구서 PDF 생성 중...',
        pdf_generated: '청구서 PDF가 성공적으로 다운로드되었습니다',
        pagination: {
          previous: '이전',
          next: '다음',
          page_of: '페이지 {{current}} / {{total}}',
        },
      },
      organization_details: {
        organization: '조직',
        subscription: '구독',
        invoices: '청구서',
        date_created: '생성일',
        organization_name: '조직 이름',
        organization_id: '조직 ID',
        leave_organization: '조직 탈퇴',
        cancel_request: '요청 취소',
        delete_organization: '조직 삭제',
        user_management: '사용자 관리',
        subscription_required: {
          title: '구독 필요',
          message: '고급 조직 기능에 접근하려면 유료 구독이 필요합니다.',
          button: '구독',
        },
        pending_approval: {
          title: '승인 대기 중',
          message:
            '이 조직에 가입 요청이 관리자에게 전송되었습니다. 승인을 기다려 주세요.',
        },
        leave_confirmation: {
          title: '조직 탈퇴',
          message:
            '"{{name}}"에서 탈퇴하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
        },
      },
      notifications: {
        title: '알림 설정',
        subtitle: '알림 환경설정을 관리하세요',
        pushNotifications: {
          label: '푸시 알림',
          description: '중요한 활동에 대한 알림을 받으려면 활성화하세요.',
          toast: {
            enabled: '푸시 알림이 성공적으로 활성화되었습니다.',
            disabled: '푸시 알림이 성공적으로 비활성화되었습니다.',
            enable_failed: '푸시 알림 활성화에 실패했습니다.',
            disable_failed: '푸시 알림 비활성화에 실패했습니다.',
          },
        },
        notificationVibration: {
          label: '알림 진동',
          description: '새 알림이 도착할 때 기기를 진동시킵니다.',
          toast: {
            enabled: '알림 진동이 활성화되었습니다.',
            disabled: '알림 진동이 비활성화되었습니다.',
            enable_failed: '알림 진동 활성화에 실패했습니다.',
            disable_failed: '알림 진동 비활성화에 실패했습니다.',
          },
        },
        notificationSound: {
          label: '알림 소리',
          description: '알림을 받을 때마다 소리를 재생합니다.',
          toast: {
            enabled: '알림 소리가 활성화되었습니다.',
            disabled: '알림 소리가 비활성화되었습니다.',
            enable_failed: '알림 소리 활성화에 실패했습니다.',
            disable_failed: '알림 소리 비활성화에 실패했습니다.',
          },
        },
        errors: {
          save_failed: '알림 환경설정을 업데이트할 수 없습니다.',
          apply_failed: '알림 환경설정을 적용할 수 없습니다.',
        },
      },
      integrations: {
        google: {
          title: 'Google 연동',
          subtitle:
            'Google 계정을 연결하여 AI 어시스턴트로 이메일을 보내고 회의를 예약하세요.',
          loading: '로딩 중...',
          connected: '연결됨',
          not_connected: '연결되지 않음',
          connect: 'Google 계정 연결',
          disconnect: '연결 해제',
          disconnected: 'Google 계정이 성공적으로 연결 해제되었습니다.',
          connect_error: 'Google 계정 연결에 실패했습니다',
          disconnect_error: 'Google 계정 연결 해제에 실패했습니다',
          features_title: '사용 가능한 기능:',
          feature_email: 'Gmail을 통한 이메일 발송',
          feature_calendar: '캘린더 이벤트 생성 및 관리',
          feature_meet: 'Google Meet으로 회의 예약',
        },
        hubspot: {
          title: 'HubSpot 연동',
          subtitle:
            'HubSpot 계정을 연결하여 CRM 데이터를 프로젝트와 동기화하세요',
          loading: '연결 확인 중...',
          connected: '연결됨',
          connected_toast: 'HubSpot 계정이 연결되었습니다',
          not_connected: '연결되지 않음',
          connect: 'HubSpot 연결',
          disconnect: '연결 해제',
          disconnected: 'HubSpot 계정 연결 해제됨',
          connect_error: 'HubSpot 연결에 실패했습니다',
          disconnect_error: 'HubSpot 계정 연결 해제에 실패했습니다',
          features_title: '사용 가능한 기능:',
          feature_contacts: '연락처 동기화',
        },
      },
      invoice_pdf: {
        generating_pdf: '청구서 PDF 생성 중...',
        pdf_generated: '청구서 PDF가 성공적으로 다운로드되었습니다',
        tokens: '토큰',
        token: '토큰',
        seats: '좌석',
        seat: '좌석',
        not_available: '해당 없음',
        token_purchase: '토큰 구매',
        plan_change: '플랜 변경',
        upgraded_to: '업그레이드:',
        downgraded_to: '다운그레이드:',
        with_proration: '비례 계산 포함',
        free_upgrade: '무료 업그레이드 - 비용 없음',
        free_downgrade: '무료 다운그레이드 - 비용 없음',
        organization: '조직',
        invoice: '청구서',
        bill_to: '청구 대상:',
        invoice_number: '청구서 번호:',
        transaction_id: '거래 ID:',
        date: '날짜:',
        payment_period: '결제 기간:',
        total: '총계:',
        thank_you: '이용해 주셔서 감사합니다!',
        page_footer: '페이지 {{current}} / {{total}}',
        service: '서비스',
        period: '기간',
        unit_fee: '단가',
        invoice_default: '청구서',
        filename_prefix: '청구서',
      },
    },
    pricing: {
      title: '요금제 및 구독',
      subtitle: '귀하의 필요에 가장 적합한 요금제를 선택하세요',
      loading: '구독 데이터를 불러오는 중...',
      select_plan: '요금제 선택',
      switch_to_plan: '{{planName}} 요금제로 전환',
      manage: '구독 관리',
      switch_to_free: '무료 요금제로 전환',
      current_plan: '현재 요금제',
      resubscribe: '다시 구독하기',
      no_changes: '변경사항 없음',
      continue_payment: '결제 계속하기',
      subscribe_with_card: '카드로 구독하기',
      processing: '처리 중...',
      payment_methods_title: '결제 수단',
      paypal: '페이팔',
      credit_card: '신용카드',
      card_coming_soon: '카드 결제 곧 지원 예정',
      login_prompt: '요금제를 구독하려면 로그인하세요',
      login_credit_prompt: '크레딧을 구매하려면 로그인하세요',
      manage_subscription: '구독 관리',
      subscription_context: '구독 컨텍스트 선택:',
      personal: '개인',
      organization: '조직',
      free_plan: '무료',
      basic_plan: '베이직',
      team_plan: '팀',
      enterprise_plan: '엔터프라이즈',
      what_included: '포함된 항목',
      show_all_features: '모든 기능 보기',
      hide_features: '기능 숨기기',
      feature_access: '기능 접근',
      seats: '좌석',
      seat: '좌석',
      current_seats: '현재 좌석 수',
      select_bundle: '번들 선택:',
      buy_now: '지금 구매하기',
      login_to_purchase: '구매하려면 로그인하세요',
      plan: '요금제',
      with_credits: '{{credits}} 크레딧 포함',
      credit_bundles: '크레딧 번들',
      monthly_recurring: '월 단위 자동 결제',
      contact_us: '문의하기',
      select_context: '컨텍스트 선택...',
      organizations: '조직',
      unknown_organization: '알 수 없는 조직',
      create_new: '새 조직 만들기',
      confirmation: {
        success_title: '구독 성공!',
        success_message: '구독이 성공적으로 업데이트되었습니다.',
        subscription_details_org:
          '<b style="color: #111827">{{orgName}}</b>의 <b style="color: #111827">{{planName}} 플랜</b>에 <b style="color: #111827">좌석 {{count}}개</b>를 구독했습니다.',
        subscription_details_personal:
          '<b style="color: #111827">{{planName}} 플랜</b>에 <b style="color: #111827">좌석 {{count}}개</b>를 구독했습니다.',
        subscription_details_personal_no_seats:
          '<b style="color: #111827">{{planName}} 플랜</b>을 구독했습니다.',
      },
      proration: {
        title: '비례 청구 상세 정보',
        description: '좌석 수 즉시 증가에 대한 추가 요금',
        amount: '비례 금액: ${{amount}}',
        billing_note: '현재 청구 주기에 추가됩니다.',
        description_details:
          '{{days}}일 동안 {{seats}}개의 추가 좌석에 대해 ${{amount}}이 청구됩니다.',
      },
      modals: {
        subscription: {
          title: '요금제 구독',
          manage_title: '구독 관리',
          upgrade_title: '요금제 업그레이드',
          downgrade_title: '요금제 다운그레이드',
          resubscribe_title: '요금제 다시 구독하기',
          back: '뒤로',
          continue: '결제 계속하기',
          cancel_subscription: '구독 취소',
          already_cancelled: '이미 취소가 예정된 구독입니다',
          no_change_needed: '변경이 필요하지 않습니다',
          manage_seats_title: '좌석 관리',
          complete_payment_title: '결제 완료',
          add_seats: '{{count}} 좌석 추가',
          add_seats_plural: '{{count}} 좌석 추가',
          remove_seats: '{{count}} 좌석 제거',
          remove_seats_plural: '{{count}} 좌석 제거',
          update_seats: '좌석 수 업데이트',
        },
        cancel_subscription: {
          title: '구독 취소',
          message: '정말로 구독을 취소하시겠습니까?',
          warning:
            '이 작업은 되돌릴 수 없습니다. 현재 청구 주기가 끝날 때까지 구독은 유지됩니다.',
          keep_subscription: '구독 유지',
          cancel_subscription: '구독 취소',
          processing: '처리 중...',
        },
      },
      toast: {
        subscription_updated: '구독이 성공적으로 업데이트되었습니다',
        subscription_cancelled: '구독이 성공적으로 취소되었습니다',
        subscription_failed: '구독 업데이트 실패',
        cancellation_failed: '구독 취소 실패',
        payment_success: '결제가 성공적으로 완료되었습니다',
        payment_failed: '결제 실패. 다시 시도해주세요.',
        credits_purchased:
          '크레딧이 성공적으로 구매되었습니다! {{credits}} 크레딧이 계정에 추가되었습니다.',
        credits_failed: '크레딧 구매 실패',
        plan_not_available_org:
          '팀 및 엔터프라이즈 요금제는 조직에서만 이용 가능합니다. 조직 탭으로 전환해주세요.',
        plan_not_available_personal:
          '개인 요금제는 개인 탭에서만 이용 가능합니다.',
        login_required: '구독하려면 로그인하세요',
        switch_context_failed: '구독 컨텍스트 전환 실패',
        refresh_failed: '구독 데이터 새로 고침 실패',
        loading_failed: '요금제 데이터 불러오기 실패',
        payment_error: '결제 중 오류가 발생했습니다. 다시 시도해주세요.',
        payment_update_failed:
          '결제는 성공했지만 계정 업데이트에 실패했습니다. 페이지를 새로고침해주세요.',
        subscriptions_load_failed: '이용 가능한 구독 불러오기 실패',
      },
      plans: {
        free: {
          name: '무료',
          description: '개인 프로젝트에 적합',
          period: '/월',
          user_limit: '1인 사용자 제한',
          credit_based_access: '크레딧 기반 접근:',
          bigger_team_note:
            '더 큰 팀을 계획하고 있나요? 우리는 당신을 위해 솔루션을 만들고 싶습니다.',
          features: {
            file_management: '파일 관리 및 미리보기',
            notifications: '알림 (개별 프로젝트)',
            multi_format_upload:
              '다양한 형식의 데이터 업로드 (2D, 3D, 비디오, 파노라마)',
            model_annotation: '모델 주석 및 내보내기',
            unlimited_tasks: '무제한 작업 및 프로젝트',
            storage: '10GB 무료 저장 공간',
          },
        },
        professional: {
          name: '프로페셔널',
          description: 'AI 및 자동화에 적합',
          period: '/월',
          user_limit: '1인 사용자 제한',
          feature_groups: {
            everything_free: '무료 플랜의 모든 기능 + 크레딧 기반 접근:',
            ai_features: 'AI 기능',
            capture_features: '캡처 기능',
            '3d_features': '3D 기능',
          },
          features: {
            credits: '1000 크레딧',
            ohive_assistant: 'O-HIVE 어시스턴트',
            model_training: '모델 학습',
            object_detection: '객체 감지',
            document_analysis: '문서 분석',
            smart_summaries: '스마트 요약',
            scene_scan: '3D 장면 스캔',
            object_scan: '객체 스캔',
            video_capture: '비디오 캡처',
            image_capture: '이미지 캡처',
            blueprint: '블루프린트',
            merging_cropping: '병합 및 자르기',
            panorama: '파노라마',
            multiple_objects: '하나의 장면에서 여러 객체 처리',
          },
        },
        team: {
          name: '팀',
          description: '팀 협업 및 자동화에 적합',
          period: '/좌석/월',
          user_limit: '2–10명 사용자',
          feature_groups: {
            everything_professional: '프로페셔널의 모든 기능 +',
            collaboration_features: '협업 기능',
            team_features: '팀 기능',
          },
          features: {
            collaboration_tools: '팀 협업 도구',
            multi_user_access: '다중 사용자 조직 접근',
            seat_management: '좌석 관리',
            roles: '역할 (관리자, 구성원, 게스트)',
            sharing_assignment: '작업 공유 및 할당',
            commenting_tagging: '동적 댓글 및 태깅',
            analytics_dashboard: '팀 분석 대시보드',
            workflow_automation: '워크플로우 자동화',
            premium_support: '프리미엄 지원',
          },
        },
        enterprise: {
          name: '엔터프라이즈',
          description: '대형 프로젝트에 적합',
          period: '/좌석/월',
          user_limit: '10–25명 사용자',
          feature_groups: {
            everything_team: '팀 및 프로페셔널의 모든 기능',
          },
          features: {
            priority_access: '신규 기능 우선 접근',
          },
        },
      },
      bundles: {
        starter: {
          name: '스타터',
          description: '소규모 프로젝트에 적합',
        },
        professional: {
          name: '프로페셔널',
          description: '정기적 사용에 적합',
        },
        enterprise: {
          name: '엔터프라이즈',
          description: '대규모 프로젝트에 최고의 가치',
        },
      },
      subscription_details: {
        title: '구독 세부정보',
        plan_name: '요금제 이름',
        status: '상태',
        billing_cycle: '청구 주기',
        seats: '좌석 수',
        next_billing: '다음 청구',
        amount: '금액',
        expires_on: '만료일',
        renewal_date: '갱신일',
        active: '활성',
        cancelled: '취소됨',
        expired: '만료됨',
        monthly: '월간',
        yearly: '연간',
        credit_balance: '크레딧 잔액',
        current_seats: '현재 좌석 수',
        desired_seats: '원하는 좌석 수',
        billing_date: '청구일',
        next_billing_date: '다음 청구일',
        billing_amount: '청구 금액',
        next_billing_amount: '다음 청구 금액',
      },
      seat_selector: {
        seats: '좌석',
        current_plan: '현재 요금제',
        new: '신규',
        seat_billed_monthly: '좌석당 월 ${{price}} 청구',
        add_seats: '좌석 추가',
      },
      billing_info: {
        billing_summary: '청구 요약',
        plan: '요금제',
        seats: '좌석 수',
        subtotal: '소계',
        total: '총액',
        monthly_total: '${{amount}} USD/월',
        prorated_charge: '추가 좌석에 대한 비례 요금',
        billing_note: '비례 금액은 즉시 청구됩니다.',
        next_charge: '다음 청구',
        cancel_note: '언제든지 취소할 수 있습니다.',
        new_monthly_plan: '새 월간 요금제 시작일',
        seats_on_plan: '{{planName}} 플랜에 {{quantity}}개 좌석',
        tax: '세금',
      },
      paypal: {
        title: '페이팔',
        approval_required: '페이팔 승인 필요',
        creating_order: '페이팔 주문 생성 중...',
        redirect_message: '결제를 완료하려면 페이팔로 이동합니다.',
        manual_redirect: '리디렉션되지 않으면 여기를 클릭하세요',
        approval_context: '페이팔을 통해 구독 결제를 완료하세요',
        loading_error: '페이팔 로딩 오류',
        retry: '재시도',
        complete_purchase: '구매 완료',
        purchasing: '구매 중...',
        purchase_details: '구매 내역: {{credits}} 크레딧, ${{price}}',
        processing_payment: '결제 처리 중...',
        loading_paypal: '페이팔 로딩 중...',
        finalizing_purchase: '구매 완료 중...',
      },
      notice: {
        proration_details_part1:
          '남은 기간 동안 {{count}}개의 추가 좌석에 대해 <b>{{amount}}</b>가 청구됩니다',
        proration_details_part1_plural:
          '남은 기간 동안 {{count}}개의 추가 좌석에 대해 <b>{{amount}}</b>가 청구됩니다',
        proration_details_part2:
          '현재 청구 기간의 {{count}}일. 다음 정기 결제 금액',
        proration_details_part2_plural:
          '현재 청구 기간의 {{count}}일. 다음 정기 결제 금액',
        proration_details_part3:
          '<b>{{amount}}</b>는 <b>{{date}}</b>에 결제될 예정입니다.',
      },
      payment_step: {
        effective_immediately: '이 변경 사항은 즉시 적용됩니다',
        charge_text: '<b>${{amount}}</b>가 지금 카드에 청구됩니다',
        processing_payment: '결제 처리 중...',
      },
      paypal_approval: {
        new_total_message:
          '새로운 월간 구독은 <b>${{newTotal}}</b>로 적용되며, 다음 청구일부터 효력이 발생합니다.',
        redirect_message:
          '이 변경을 확인하기 위해 페이팔로 리디렉션됩니다. 즉시 결제는 발생하지 않습니다.',
      },
    },
    privacy: {
      title: '럭솔리스 - 개인정보 처리방침',
      lastUpdated: '마지막 업데이트: 2025년 4월 21일',
      whoAreWe: '우리는 누구인가요?',
      whoAreWeContent:
        '우리 회사인 LuxPM 주식회사(사업자등록번호: 549-81-01935, 대한민국 소재)는 귀하의 개인정보 보호를 위해 최선을 다하고 있습니다. 본 개인정보 처리방침은 O-HIVE 플랫폼을 포함한 당사 서비스와 상호작용할 때 귀하의 정보를 어떻게 수집, 처리, 사용 및 보호하는지 설명합니다.',
      regulations: '어떤 규정을 준수하나요?',
      regulationsContent:
        '우리는 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률을 포함한 대한민국의 모든 관련 법률과 규정을 준수합니다. 해외 사용자의 경우, 글로벌 개인정보 보호 기준에 부합하는 모범 사례도 준수합니다.',
      dataProcessing: {
        title: '1. 개인정보를 왜, 어떻게 처리하나요?',
        reasons: [
          {
            title: '서비스 제공을 위해',
            content:
              '계약상 의무를 이행하고 귀하가 구독한 서비스를 제공하기 위해 개인정보를 처리합니다.',
          },
          {
            title: '사용자 계정 생성 및 관리',
            content:
              '귀하의 개인정보는 당사 플랫폼에서 사용자 계정을 생성하고 유지하는 데 사용됩니다.',
          },
          {
            title: '서비스 기능',
            content:
              'O-HIVE 플랫폼과 웹사이트의 원활한 사용을 위해 서비스 신뢰성과 성능에 대한 당사의 정당한 이익을 기반으로 데이터를 처리합니다.',
          },
          {
            title: '법적 청구',
            content:
              '당사의 법적 권리를 보호하고 규제 요구사항을 준수하기 위해 개인정보를 처리할 수 있습니다.',
          },
          {
            title: '뉴스레터 및 업데이트',
            content:
              '귀하의 동의 하에 연락처 정보를 사용하여 업데이트나 홍보 자료를 보낼 수 있습니다. 언제든지 구독을 취소할 수 있습니다.',
          },
          {
            title: '법적 의무 준수',
            content:
              '전기통신사업법상 판매신고 및 전자상거래 등과 관련된 대한민국 법률에 따른 법적 의무에 따라 개인정보를 처리할 수 있습니다.',
          },
          {
            title: '고객 지원',
            content:
              '지원 요청을 처리하고 사용자 경험을 개선하기 위해 개인정보를 처리합니다.',
          },
          {
            title: '분석',
            content:
              '서비스를 개선하기 위해 정당한 이익을 기반으로 사용 패턴을 분석합니다. 해당되는 경우 데이터는 익명화됩니다.',
          },
          {
            title: '마케팅',
            content:
              '귀하의 명시적인 동의 하에 마케팅 활동을 개인화하고 개선하기 위해 데이터를 처리할 수 있습니다.',
          },
          {
            title: '아동 데이터',
            content:
              '당사 서비스는 14세 미만의 개인을 대상으로 하지 않습니다. 당사는 고의로 아동의 개인정보를 수집하지 않습니다. 실수로 그러한 데이터를 수집한 것을 알게 되면 즉시 삭제 조치를 취합니다.',
          },
        ],
      },
      personalData: {
        title: '2. 어떤 개인정보를 처리하나요?',
        intro: '다음과 같은 범주의 데이터를 수집할 수 있습니다:',
        categories: [
          {
            title: '식별 데이터:',
            content: '이름, 이메일 주소, 비밀번호',
          },
          {
            title: '연락처 데이터:',
            content: '전화번호, 주소',
          },
          {
            title: '거래 데이터:',
            content: '결제 기록, 거래 날짜 및 금액',
          },
          {
            title: '기기 및 네트워크 식별자:',
            content: 'IP 주소, 기기 ID, 쿠키',
          },
          {
            title: '통신 데이터:',
            content: '메시지, 사용자 상호작용, 설문 응답',
          },
        ],
      },
      dataRetention: {
        title: '3. 데이터 보관',
        intro:
          '설명된 목적을 달성하는 데 필요한 기간 동안만 데이터를 보관합니다:',
        periods: [
          {
            title: '사용자 계정:',
            content: '계정이 활성화되어 있는 동안 보관',
          },
          {
            title: '법적 청구 또는 분쟁:',
            content: '사건 기간 및 적용 가능한 소멸시효 기간 동안 보관',
          },
          {
            title: '뉴스레터:',
            content: '구독 취소할 때까지 보관하되, 최대 2년',
          },
          {
            title: '분석:',
            content: '동의가 철회될 때까지 최대 5년간 보관',
          },
          {
            title: '법적 의무:',
            content: '법률이 요구하는 기간 동안 보관',
          },
        ],
      },
      dataSharing: {
        title: '4. 데이터 공유 및 전송',
        points: [
          {
            title: '처리자:',
            content:
              '당사의 지시에 따라 데이터를 처리하는 제3자 서비스 제공업체(예: IT 서비스 제공업체, 분석 도구)와 협력합니다.',
          },
          {
            title: '관리자:',
            content:
              '해당되는 경우 결제 처리업체(예: PayPal, Braintree)와 데이터를 공유할 수 있습니다.',
          },
          {
            title: '국제 전송:',
            content:
              '데이터가 대한민국 외부로 전송되는 경우, 해당 전송이 적용 가능한 규정에 따른 필요한 보호 조치를 충족하도록 합니다.',
          },
        ],
      },
      yourRights: {
        title: '5. 귀하의 권리',
        intro: '데이터 주체로서 귀하는 다음을 할 수 있습니다:',
        rights: [
          '데이터에 대한 접근을 요청',
          '정정을 요청',
          '해당되는 경우 삭제를 요청',
          '처리에 이의를 제기하거나 제한을 요청',
          '언제든지 동의를 철회',
          '기술적으로 가능한 경우 데이터 이전을 요청',
        ],
        contact: '이러한 권리를 행사하려면 다음으로 연락하세요:',
      },
      cookies: {
        title: '6. 쿠키',
        pointTitle1: '쿠키는 다음을 위해 사용됩니다:',
        pointList1: [
          '귀하의 선호도를 기억',
          '로그인 세션 활성화',
          '사용자 경험 및 분석 개선 (예: Google Analytics)',
        ],
        pointTitle2:
          '브라우저나 당사 사이트의 쿠키 설정 도구를 통해 쿠키 설정을 관리할 수 있습니다.',
      },
      contact: {
        title: '연락처 정보',
        company: '럭스피엠 주식회사',
        reportNumber: '전기통신사업법상 판매신고번호: 2022-성남분당C-0435',
        address1:
          '사업장 주소: 서울특별시 송파구 문정동645 H비지니스파크 A동412호',
        address2: '서울시 송파구 문정동645 H비지니스파크 A동412호',
      },
    },
    publicModels: {
      title: 'Luxolis 3D 비전 & 로보틱스 마켓플레이스 (제품 카탈로그)',
      description:
        '현실 세계의 3D 프로젝트와 솔루션을 탐색하세요. 최첨단 3D 비전 기술을 기반으로 한 제품과 서비스를 소개하고, 판매하거나 예약할 수 있습니다.',
    },
  },
  components: {
    loginMessage: {
      message: 'access',
      loggedIn: 'logged in',
      mustBe: 'You must be ',
      postComment: 'post a comment',
      replyComment: 'reply to this comment',
    },
  },
  toast: {
    itemLoadsError: {
      title: 'Failed to load items',
      description:
        'First chunk of models did not complete within the expected time.',
    },
    uploadFilesError: {
      title: 'No Permission',
      description:
        'Upload failed: You do not have edit permissions on this file.',
    },
    uploadFilesError: {
      title: 'No Permission',
      description:
        'Upload failed: You do not have edit permissions on this file.',
    },
    changeTypeTeamError:
      '조직에 가입하거나 조직을 선택해야 팀 프로젝트를 사용할 수 있습니다',
  },
  viewer: {
    vtProcessing: {
      title: '모델 최적화 중',
      description:
        '텍스처 스트리밍을 위해 모델을 최적화하고 있습니다. 보통 몇 분 정도 소요됩니다.',
      checking: '상태 확인 중...',
      checkNow: '지금 확인',
      complete: '모델 최적화 완료! 로딩 중...',
      failed: '모델 최적화 실패. 원본 모델로 다시 로드합니다...',
      failedDescription: '최적화에 실패했습니다. 원본 모델이 대신 로드됩니다.',
      errorGeneric: '처리 중 오류가 발생했습니다.',
      loadOriginal: '원본 모델 로드',
      stillProcessing: '아직 처리 중... 곧 다시 확인합니다.',
      checkFailed: '상태를 확인할 수 없습니다. 다시 시도합니다.',
      steps: {
        queued: '대기 중',
        downloading: '모델 다운로드 중',
        validating: '모델 검증 중',
        processing: '텍스처 처리 중',
        processingDesktop: '데스크톱 프로필 처리 중',
        processingLow: '모바일 프로필 처리 중',
        uploading: '결과 업로드 중',
        completed: '완료',
        failed: '실패',
      },
    },
  },
};
